/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onDeltaOrder = /* GraphQL */ `
  subscription OnDeltaOrder($orderLocationId: ID!) {
    onDeltaOrder(orderLocationId: $orderLocationId) {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      giftReceiverKey
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      note
      request
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      orderCustomer {
        id
        enterpriseId
        storeId
        locationId
        customerId
        provider
        providerCustomerId
        shopNo
        tier
        tierId
        customerCreatedAt
        ident
        identType
        type
        name
        nameKeyword
        payments {
          id
          method
          pg
          number
          name
          expMonth
          expYear
          billingKey
          updatedAt
          createdAt
        }
        attributes {
          name
          type
          value
        }
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        tags {
          tagId
          createdLocationId
        }
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        salesDate
        campaignBlockedAt
        blacklistedAt
        isFavorite
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
    }
  }
`;
export const onOrderDelta = /* GraphQL */ `
  subscription OnOrderDelta($orderLocationId: ID!) {
    onOrderDelta(orderLocationId: $orderLocationId) {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      giftReceiverKey
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      request
      note
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      timestamp
      expdate
    }
  }
`;
export const onOrderDeltaByStore = /* GraphQL */ `
  subscription OnOrderDeltaByStore($storeId: ID!) {
    onOrderDeltaByStore(storeId: $storeId) {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      giftReceiverKey
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      request
      note
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      timestamp
      expdate
    }
  }
`;
export const onOrderDeltaByCustomer = /* GraphQL */ `
  subscription OnOrderDeltaByCustomer($customerId: ID!) {
    onOrderDeltaByCustomer(customerId: $customerId) {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      giftReceiverKey
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      request
      note
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdatedRequestProgressEvent = /* GraphQL */ `
  subscription OnUpdatedRequestProgressEvent($originId: ID!) {
    onUpdatedRequestProgressEvent(originId: $originId) {
      id
      origin
      originId
      func
      params
      status
      progress
      errorMessage
      doneAt
      updatedAt
      createdAt
    }
  }
`;
export const onDeltaStoreCustomer = /* GraphQL */ `
  subscription OnDeltaStoreCustomer($storeId: ID!) {
    onDeltaStoreCustomer(storeId: $storeId) {
      id
      customerId
      storeId
      sources {
        id
        type
        name
        ident
        createdAt
      }
      isFavorite
      locationId
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      favoriteLocationIds
      visitedLocationIds
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      status
      registeredAt
      campaignBlockedAt
      note
      removedAt
      updatedAt
      createdAt
      points {
        items {
          id
          locationId
          storeId
          type
          name
          method
          amount
          origin
          provider
          providerCustomerId
          providerShopNo
          providerSyncedAt
          currency
          point
          extraPoint
          extraExpire
          items {
            type
            itemId
            name
            parentId
            point
            amount
            quantity
          }
          quantity
          note
          orderId
          referId
          orderNumberPrefix
          orderNumber
          customerId
          pointTransactionCustomerId
          expiredAt
          salesDate
          eventId
          updatedAt
          createdAt
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
        }
        nextToken
      }
      credits {
        items {
          id
          locationId
          storeId
          name
          type
          amount
          origin
          note
          currency
          parentId
          orderId
          orderNumberPrefix
          orderNumber
          customerId
          creditTransactionCustomerId
          description
          salesDate
          createdAt
          updatedAt
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
        }
        nextToken
      }
      _delta
      orders {
        items {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          giftReceiverKey
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
        nextToken
      }
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
      customer {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onStoreCustomerDelta = /* GraphQL */ `
  subscription OnStoreCustomerDelta($storeId: ID!) {
    onStoreCustomerDelta(storeId: $storeId) {
      id
      customerId
      storeId
      locationId
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      campaignBlockedAt
      isFavorite
      favoriteLocationIds
      visitedLocationIds
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      customer {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onChangedCustomer = /* GraphQL */ `
  subscription OnChangedCustomer {
    onChangedCustomer {
      id
      ident
      identType
      type
      name
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      updatedAt
      createdAt
      stores {
        items {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const onUpdatedStore = /* GraphQL */ `
  subscription OnUpdatedStore($id: ID!) {
    onUpdatedStore(id: $id) {
      id
      enterpriseId
      info {
        name
        phone
        email
        representative
        businessType
        businessNumber
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        industryType
        sendNumber
        currency
        address
        zip
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        csPhone
      }
      policy {
        multiLocation
        provider {
          key
          ident
          customer
          customerQr
          coupon
          inventory
          inventoryLocationId
          locationId
          userId
          userPassword
          shopMap {
            storeId
            shopNo
            name
            originName
            countryCode
            usableCouponIds
            currencyCode
            tiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
        }
        app {
          locationId
        }
      }
      currency
      payments {
        card
        cardJoined
        cash
        credit
        refund
      }
      devices {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      plans {
        menus {
          id
          name
          mode
          size
          menus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          pages {
            index
            parentId
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            title
            titleMl {
              en
              zh
              ja
            }
          }
          updatedAt
          createdAt
        }
        orders {
          id
          name
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          updatedAt
          createdAt
        }
      }
      taxes {
        id
        type
        name
        enabled
        rate
        method
        targetType
      }
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      subscription {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        updatedAt
        createdAt
      }
      view {
        order {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
        itemReport {
          excludeColumns
        }
        summaryReport {
          excludeColumns
        }
        shippingOrder {
          excludeColumns
        }
        trsItemReport {
          excludeColumns
        }
        customReport {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
      }
      settings {
        mode
        table
        diningOption
        retailOption
        orderAlarm
        orderConfirm
        addressInput
        autoPay
        autoReturnItem
        autoSoldout
        menuGridSize
        menuMode
        tableMode
        orderNotify
        orderNotifySkippable
        disablePhonePrefix
        autoCloseScreen
        orderNumberPrefix {
          pos
          kiosk
          menuOrder
        }
        orderMgmt {
          kiosk
          menuorder
          delivery
          pos
        }
        reportBasis
        orderOrigins
        beeper {
          active
          coverage
          skippable
        }
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        customerOptions {
          countries
          ages
          gender
        }
      }
      item {
        attributes {
          name
          type
          value
        }
        actualPrice
        skuMgmt
        barcodeMgmt
        stockTrack
        variablePrice
        locationCreatable
      }
      inventory {
        attributes {
          name
          type
          value
        }
        expiryDateMgmt
        expiryDateAlertDays
        hqWhExposureEnabled
        hqWhExposureLocIds
        hqWhUnexposureLocIds
        customAdjustDateEnabled
      }
      customer {
        attributes {
          name
          type
          value
        }
      }
      billing {
        key
        businessNumber
        name
        email
        phone
        contanctName
        contactName
        address
        zip
        card {
          pg
          number
          name
          expMonth
          expYear
          identify
          password
          billingKey
        }
      }
      credit {
        autoCharge
        autoChargeCredit
        autoChargeQuantity
        alertCredit
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      review {
        status
        campaignId
        updatedAt
        createdAt
      }
      kiosk {
        status
        callable
        payable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        exchangeTicket
        columnSize
        discounts {
          condition
          couponId
        }
        menuDescription
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        titles
        titlePosition
        updatedAt
        createdAt
      }
      menuOrder {
        callOptions {
          index
          label
        }
        orderable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        columnSize
        fontSize
        notice
        resetTime
        enableCash
        boardType
      }
      kds {
        layout
        alerts {
          urgent
          warning
        }
        disabledProdIds
        orderNotify
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      market {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        paused
        takeoutDiscount
        creditDiscount
        takeout
        intro
        notice
        bookTable
        bookTableNote
        depositAmount
        delivery
        deliveryFee {
          start
          end
          fee
        }
        waitingTime
        itemIds
        updatedAt
        createdAt
      }
      notification {
        options {
          type
          email
          sms
        }
      }
      groups {
        items {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      locations {
        items {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const onUpdatedStoreStatus = /* GraphQL */ `
  subscription OnUpdatedStoreStatus($id: ID!) {
    onUpdatedStoreStatus(id: $id) {
      id
      item {
        func
        progress
        errorMessage
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdatedLocationCustomerDelta = /* GraphQL */ `
  subscription OnUpdatedLocationCustomerDelta($locationId: ID!) {
    onUpdatedLocationCustomerDelta(locationId: $locationId) {
      id
      enterpriseId
      storeId
      locationId
      customerId
      provider
      providerCustomerId
      shopNo
      tier
      tierId
      customerCreatedAt
      ident
      identType
      type
      name
      nameKeyword
      payments {
        id
        method
        pg
        number
        name
        expMonth
        expYear
        billingKey
        updatedAt
        createdAt
      }
      attributes {
        name
        type
        value
      }
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      tags {
        tagId
        createdLocationId
      }
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      salesDate
      campaignBlockedAt
      blacklistedAt
      isFavorite
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      subscriptions {
        id
        planId
        payStatus
        sessionId
        nextPayDate
        paidAt
        unsubscribedAt
        used
        lastUsedAt
        orderId
        unsubscribeRequestedAt
        startDate
        expireDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onChangedLocation = /* GraphQL */ `
  subscription OnChangedLocation($storeId: ID!) {
    onChangedLocation(storeId: $storeId) {
      id
      name
      type
      code
      brand
      brandId
      provider
      address
      zip
      phone
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      representative
      businessNumber
      billing {
        key
        businessNumber
        name
        email
        phone
        contanctName
        contactName
        address
        zip
        card {
          pg
          number
          name
          expMonth
          expYear
          identify
          password
          billingKey
        }
      }
      credit {
        autoCharge
        autoChargeCredit
        autoChargeQuantity
        alertCredit
      }
      businessHours {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      storeId
      state
      menuPlanId
      payments {
        refund
        barcode
        barcodeVan
        barcodeTerminalId
      }
      policy {
        locationCost
        loyaltyCost
      }
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      kiosk {
        status
        callable
        payable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        exchangeTicket
        columnSize
        discounts {
          condition
          couponId
        }
        menuDescription
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        titles
        titlePosition
        updatedAt
        createdAt
      }
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      menuOrder {
        callOptions {
          index
          label
        }
        orderable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        columnSize
        fontSize
        notice
        resetTime
        enableCash
        boardType
      }
      kds {
        layout
        alerts {
          urgent
          warning
        }
        disabledProdIds
        orderNotify
      }
      mini {
        defaultItemName
      }
      orderPlanId
      menu {
        board {
          textSize
          columnSize
          pages {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          favorite {
            parentId
            badge
            type
            position
            activeOptions
          }
          enableFavorite
        }
        list {
          pages {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          favorite {
            parentId
            badge
            type
            position
            activeOptions
          }
          shortcuts {
            type
            title
            itemName
            itemPrice
            active
          }
        }
        navOrder
      }
      menus {
        parentId
        position
        page
        pageTitle
      }
      favMenus {
        parentId
        position
        page
        pageTitle
      }
      catMenus {
        title
        index
        ids
        parentId
      }
      market {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        paused
        takeoutDiscount
        creditDiscount
        takeout
        intro
        notice
        bookTable
        bookTableNote
        depositAmount
        delivery
        deliveryFee {
          start
          end
          fee
        }
        waitingTime
        itemIds
        updatedAt
        createdAt
      }
      waiting {
        status
        waitingOptions {
          id
          type
          name
          nameMl {
            en
            zh
            ja
          }
          items {
            id
            name
            nameMl {
              en
              zh
              ja
            }
            limitQuantity
          }
          required
          updatedAt
          createdAt
        }
        waitingMinutes
        waitingMinutesHide
        hasForeigner
        foreignerMethod
        notifications {
          created
          ready
          requested
          cancelled
        }
        notices {
          createdNotice
          createdNoticeMl {
            en
            zh
            ja
          }
          requestedNotice
          requestedNoticeMl {
            en
            zh
            ja
          }
        }
        settings {
          autoCancel
          autoCancelMinutes
        }
        updatedAt
        createdAt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      view {
        order {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
        itemReport {
          excludeColumns
        }
        summaryReport {
          excludeColumns
        }
        shippingOrder {
          excludeColumns
        }
        trsItemReport {
          excludeColumns
        }
        customReport {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
      }
      subscription {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        updatedAt
        createdAt
      }
      settings {
        mode
        table
        diningOption
        retailOption
        orderAlarm
        orderConfirm
        addressInput
        autoPay
        autoReturnItem
        autoSoldout
        menuGridSize
        menuMode
        tableMode
        orderNotify
        orderNotifySkippable
        disablePhonePrefix
        autoCloseScreen
        orderNumberPrefix {
          pos
          kiosk
          menuOrder
        }
        orderMgmt {
          kiosk
          menuorder
          delivery
          pos
        }
        reportBasis
        orderOrigins
        beeper {
          active
          coverage
          skippable
        }
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        customerOptions {
          countries
          ages
          gender
        }
      }
      devices {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      tables {
        id
        width
        height
        name
        axisX
        axisY
        screenHeight
        screenWidth
        initialX
        initialY
        shape
        layout {
          x
          y
          w
          h
        }
        color
        orderId
        disabled
      }
      boardTables {
        title
        index
        items {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
      }
      gridTables {
        id
        name
        orderId
        index
        page
      }
      modifierSoldoutIds
      delivery {
        baemin
        coupang
        yogiyo
        enableGenProd
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
      sales {
        startedAt
        endedAt
        reserves
        actualBalance
        currency
        note
        estimateBalance
        detail {
          totalSales
          totalRefund
          totalTax
          totalDiscount
          supplyAmount
          totalSalesCount
          cash {
            sales
            refund
          }
          card {
            sales
            refund
          }
          credit {
            sales
            refund
          }
          barcode {
            sales
            refund
          }
          extra {
            sales
            refund
          }
          refund {
            sales
            refund
          }
          products {
            id
            name
            quantity
            amount
          }
          origins {
            pos
            kiosk
            menuorder
            delivery
            market
          }
        }
        reservesHistories {
          type
          amount
          note
          createdEmployeeId
          createdAt
        }
      }
    }
  }
`;
export const onChangedBrand = /* GraphQL */ `
  subscription OnChangedBrand($storeId: ID!) {
    onChangedBrand(storeId: $storeId) {
      id
      storeId
      name
      code
      description
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      state
      phone
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      menuPlanId
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      order
      createdAt
      updatedAt
    }
  }
`;
export const onDeletedBrand = /* GraphQL */ `
  subscription OnDeletedBrand($storeId: ID!) {
    onDeletedBrand(storeId: $storeId) {
      id
      storeId
      name
      code
      description
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      state
      phone
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      menuPlanId
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      order
      createdAt
      updatedAt
    }
  }
`;
export const onCreatedCredit = /* GraphQL */ `
  subscription OnCreatedCredit($storeId: ID!) {
    onCreatedCredit(storeId: $storeId) {
      id
      locationId
      storeId
      name
      type
      amount
      origin
      note
      currency
      parentId
      orderId
      orderNumberPrefix
      orderNumber
      customerId
      creditTransactionCustomerId
      description
      salesDate
      createdAt
      updatedAt
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
    }
  }
`;
export const onCreatedPoint = /* GraphQL */ `
  subscription OnCreatedPoint($storeId: ID) {
    onCreatedPoint(storeId: $storeId) {
      id
      locationId
      storeId
      type
      name
      method
      amount
      origin
      provider
      providerCustomerId
      providerShopNo
      providerSyncedAt
      currency
      point
      extraPoint
      extraExpire
      items {
        type
        itemId
        name
        parentId
        point
        amount
        quantity
      }
      quantity
      note
      orderId
      referId
      orderNumberPrefix
      orderNumber
      customerId
      pointTransactionCustomerId
      expiredAt
      salesDate
      eventId
      updatedAt
      createdAt
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
    }
  }
`;
export const onChangedMessage = /* GraphQL */ `
  subscription OnChangedMessage($locationId: ID!) {
    onChangedMessage(locationId: $locationId) {
      id
      enterpriseId
      storeId
      locationId
      priority
      read
      type
      title
      body
      action {
        category
        method
        args
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdatedItems = /* GraphQL */ `
  subscription OnUpdatedItems($id: ID!) {
    onUpdatedItems(id: $id) {
      id
      products {
        type
        id
        itemId
        name
        description
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        image
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        locationIds
      }
      productModifiers {
        productId
        modifierId
      }
      categoryProducts {
        categoryId
        productId
      }
      modifiers {
        type
        id
        itemId
        name
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        locationIds
      }
      categories {
        type
        id
        itemId
        name
        displayName
        locationIds
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdatedProduct = /* GraphQL */ `
  subscription OnUpdatedProduct($storeId: ID!) {
    onUpdatedProduct(storeId: $storeId) {
      id
      type
      enterpriseId
      storeId
      origin
      refer
      referId
      name
      nameMl {
        en
        zh
        ja
      }
      description
      descriptionMl {
        en
        zh
        ja
      }
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      variablePrice
      attributes {
        name
        type
        value
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      categories {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      classifications {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      modifiers {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onDeletedProduct = /* GraphQL */ `
  subscription OnDeletedProduct($storeId: ID!) {
    onDeletedProduct(storeId: $storeId) {
      id
      type
      enterpriseId
      storeId
      origin
      refer
      referId
      name
      nameMl {
        en
        zh
        ja
      }
      description
      descriptionMl {
        en
        zh
        ja
      }
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      variablePrice
      attributes {
        name
        type
        value
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      categories {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      classifications {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      modifiers {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onUpdatedCategory = /* GraphQL */ `
  subscription OnUpdatedCategory($storeId: ID!) {
    onUpdatedCategory(storeId: $storeId) {
      type
      id
      code
      enterpriseId
      storeId
      name
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      depth
      parentCategoryId
      active
      refer
      referId
      sortKey
      subCategoryProductDisplay
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onDeletedCategory = /* GraphQL */ `
  subscription OnDeletedCategory($storeId: ID!) {
    onDeletedCategory(storeId: $storeId) {
      type
      id
      code
      enterpriseId
      storeId
      name
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      depth
      parentCategoryId
      active
      refer
      referId
      sortKey
      subCategoryProductDisplay
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onUpdatedModifier = /* GraphQL */ `
  subscription OnUpdatedModifier($storeId: ID!) {
    onUpdatedModifier(storeId: $storeId) {
      id
      type
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      origin
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onDeletedModifier = /* GraphQL */ `
  subscription OnDeletedModifier($storeId: ID!) {
    onDeletedModifier(storeId: $storeId) {
      id
      type
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      origin
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onUpdatedMessage = /* GraphQL */ `
  subscription OnUpdatedMessage($locationId: ID!) {
    onUpdatedMessage(locationId: $locationId) {
      id
      enterpriseId
      storeId
      locationId
      priority
      read
      type
      title
      body
      action {
        category
        method
        args
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdatedCoupon = /* GraphQL */ `
  subscription OnUpdatedCoupon($storeId: ID!) {
    onUpdatedCoupon(storeId: $storeId) {
      id
      storeId
      enterpriseId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      provider
      providerCouponId
      name
      description
      availableOrigins
      code
      type
      method
      tranCount
      generateCount
      publishCount
      limitPublishCount
      duplicatePublish
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionItemsOperator
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      referId
      validDateType
      validValue
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      notice
      pointSavable
      startedAt
      endedAt
      updatedAt
      createdAt
      transactions {
        items {
          id
          usedAt
          state
          amount
          quantity
          refundedAt
          orderId
          customerId
          couponTransactionCustomerId
          updatedAt
          createdAt
          expiredDate
          barcode
          generateLocationId
          generatedAt
          couponTransactionsId
          enterpriseId
          storeId
          locationId
          activeLocationIds
          inactiveLocationIds
          publishableLocationIds
          provider
          providerCouponId
          providerTransactionId
          providerCustomerId
          providerShopNo
          name
          code
          type
          method
          conditionType
          conditionQuantity
          conditionAmount
          conditionItems
          conditionTimes {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          conditionTier
          conditionMinAmount
          conditionMaxAmount
          discountMethod
          discountValue
          applyScope
          applyItemId
          applyCandidateItemIds
          applyCandidateItemModels
          applyExcludeItemModels
          campaignId
          eventId
          startedAt
          endedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdatedCouponTransaction = /* GraphQL */ `
  subscription OnUpdatedCouponTransaction($storeId: ID) {
    onUpdatedCouponTransaction(storeId: $storeId) {
      id
      usedAt
      state
      amount
      quantity
      refundedAt
      orderId
      customerId
      couponTransactionCustomerId
      updatedAt
      createdAt
      expiredDate
      barcode
      generateLocationId
      generatedAt
      couponTransactionsId
      enterpriseId
      storeId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      provider
      providerCouponId
      providerTransactionId
      providerCustomerId
      providerShopNo
      name
      code
      type
      method
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      campaignId
      eventId
      startedAt
      endedAt
    }
  }
`;
export const onCreatedNoticeCampaignResult = /* GraphQL */ `
  subscription OnCreatedNoticeCampaignResult($recipientLocationId: ID!) {
    onCreatedNoticeCampaignResult(recipientLocationId: $recipientLocationId) {
      id
      recipientStoreId
      recipientLocationId
      campaignId
      noticeId
      notice {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      read
      updatedAt
      createdAt
    }
  }
`;
export const onItemDelta = /* GraphQL */ `
  subscription OnItemDelta($storeId: ID!) {
    onItemDelta(storeId: $storeId) {
      id
      itemId
      type
      code
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      attributes {
        name
        type
        value
      }
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      brandIds
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      active
      origin
      refer
      referId
      depth
      parentId
      parentCategoryId
      sortKey
      subCategoryProductDisplay
      description
      descriptionMl {
        en
        zh
        ja
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      variablePrice
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      ordering
      categoryIds
      classificationIds
      modifierIds
      productIds
      locationIds
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdatedCustomerTag = /* GraphQL */ `
  subscription OnUpdatedCustomerTag($storeId: ID!) {
    onUpdatedCustomerTag(storeId: $storeId) {
      id
      label
      description
      color
      customerIds
      storeId
      locationId
      type
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeletedCustomerTag = /* GraphQL */ `
  subscription OnDeletedCustomerTag($storeId: ID!) {
    onDeletedCustomerTag(storeId: $storeId) {
      id
      label
      description
      color
      customerIds
      storeId
      locationId
      type
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdatedSubscriptionPlanDelta = /* GraphQL */ `
  subscription OnUpdatedSubscriptionPlanDelta($storeId: ID!) {
    onUpdatedSubscriptionPlanDelta(storeId: $storeId) {
      id
      storeId
      productId
      skuId
      name
      recurringType
      recurringValue
      price
      quantity
      status
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      gracePeriod
      subscriberCount
      locations {
        planId
        locationId
        available
        subscriberCount
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onUpdatedLocationDeviceDelta = /* GraphQL */ `
  subscription OnUpdatedLocationDeviceDelta($storeId: ID!) {
    onUpdatedLocationDeviceDelta(storeId: $storeId) {
      id
      ident
      storeId
      locationId
      system
      ipAddress
      brand
      model
      name
      type
      deviceType
      display {
        height
        width
      }
      protocol
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      barcodeReader
      appVersion
      sysVersion
      status
      password
      msgToken
      msgTokenStatus
      parentId
      childId
      sleepMode
      kioskOptions {
        mode
        isActive
        tableId
        orderId
        callable
        payable
        enableDiningOption
        resetTime
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        columnSize
      }
      menuOrderOptions {
        tableId
        orderId
      }
      terminalId
      orderOptions {
        cycleNumber
      }
      printOptions {
        port
        baudRate
        receipt
        receiptButtonHide
        storeNameHide
        bills
        refund
        salesEnd
        order
        orderBeep
        orderCount
        orderExcludeIds
        delivery
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdatedCustomerRequestDelta = /* GraphQL */ `
  subscription OnUpdatedCustomerRequestDelta($locationId: ID!) {
    onUpdatedCustomerRequestDelta(locationId: $locationId) {
      id
      storeId
      locationId
      messages
      orderId
      tableId
      parentDeviceId
      childDeviceId
      confirmedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdatedCustomerTagDelta = /* GraphQL */ `
  subscription OnUpdatedCustomerTagDelta($storeId: ID!) {
    onUpdatedCustomerTagDelta(storeId: $storeId) {
      id
      type
      label
      description
      color
      storeId
      locationId
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdatedOrderTicketDelta = /* GraphQL */ `
  subscription OnUpdatedOrderTicketDelta($locationId: ID!) {
    onUpdatedOrderTicketDelta(locationId: $locationId) {
      id
      storeId
      locationId
      orderId
      items {
        id
        diningState
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      order {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        giftReceiverKey
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
    }
  }
`;
export const onCreateSalesOrder = /* GraphQL */ `
  subscription OnCreateSalesOrder {
    onCreateSalesOrder {
      id
      name
      state
      method
      address1
      address2
      amount
      tax
      origin
      phone
      email
      itemName
      returnUrl
      payment
      items {
        item
        qty
      }
      orderId
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateSalesOrder = /* GraphQL */ `
  subscription OnUpdateSalesOrder {
    onUpdateSalesOrder {
      id
      name
      state
      method
      address1
      address2
      amount
      tax
      origin
      phone
      email
      itemName
      returnUrl
      payment
      items {
        item
        qty
      }
      orderId
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteSalesOrder = /* GraphQL */ `
  subscription OnDeleteSalesOrder {
    onDeleteSalesOrder {
      id
      name
      state
      method
      address1
      address2
      amount
      tax
      origin
      phone
      email
      itemName
      returnUrl
      payment
      items {
        item
        qty
      }
      orderId
      updatedAt
      createdAt
    }
  }
`;
export const onCreateLocationSettlement = /* GraphQL */ `
  subscription OnCreateLocationSettlement {
    onCreateLocationSettlement {
      locationId
      transactionDate
      storeId
      status
      amount
      amountSettled
      transactionAmount
      fee
      carryOrverAmount
      items {
        category
        status
        amount
        amountSettled
        fee
        brokerageRate
        brokerageFee
        cardRate
        cardFee
        cardAmount
        transactions {
          orderId
          amount
          type
          ident
          name
          approvalDate
          approvalNumber
          createdAt
        }
        carryOrverAmount
        carries {
          transactionDate
          amount
        }
        request
        response
        result
        requestSettleDate
        estimateDate
        settledAt
      }
      tryCount
      estimateDate
      requestSettleDate
      settledAt
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateLocationSettlement = /* GraphQL */ `
  subscription OnUpdateLocationSettlement {
    onUpdateLocationSettlement {
      locationId
      transactionDate
      storeId
      status
      amount
      amountSettled
      transactionAmount
      fee
      carryOrverAmount
      items {
        category
        status
        amount
        amountSettled
        fee
        brokerageRate
        brokerageFee
        cardRate
        cardFee
        cardAmount
        transactions {
          orderId
          amount
          type
          ident
          name
          approvalDate
          approvalNumber
          createdAt
        }
        carryOrverAmount
        carries {
          transactionDate
          amount
        }
        request
        response
        result
        requestSettleDate
        estimateDate
        settledAt
      }
      tryCount
      estimateDate
      requestSettleDate
      settledAt
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteLocationSettlement = /* GraphQL */ `
  subscription OnDeleteLocationSettlement {
    onDeleteLocationSettlement {
      locationId
      transactionDate
      storeId
      status
      amount
      amountSettled
      transactionAmount
      fee
      carryOrverAmount
      items {
        category
        status
        amount
        amountSettled
        fee
        brokerageRate
        brokerageFee
        cardRate
        cardFee
        cardAmount
        transactions {
          orderId
          amount
          type
          ident
          name
          approvalDate
          approvalNumber
          createdAt
        }
        carryOrverAmount
        carries {
          transactionDate
          amount
        }
        request
        response
        result
        requestSettleDate
        estimateDate
        settledAt
      }
      tryCount
      estimateDate
      requestSettleDate
      settledAt
      updatedAt
      createdAt
    }
  }
`;
export const onCreateSettlement = /* GraphQL */ `
  subscription OnCreateSettlement {
    onCreateSettlement {
      storeId
      transactedAt
      status
      enterpriseId
      locationId
      amount
      amountSettled
      estimateDate
      settledAt
      transactionAmount
      tryCount
      requestSettleDate
      request
      response
      result
      brokerageFee
      cardBrokerageFee
      cardBrokerageRate
      carryOrverAmount
      creditAmount
      creditBrokerageRate
      creditBrokerageFee
      billingStatus
      amountBilled
      billedAt
      billingHistoryId
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateSettlement = /* GraphQL */ `
  subscription OnUpdateSettlement {
    onUpdateSettlement {
      storeId
      transactedAt
      status
      enterpriseId
      locationId
      amount
      amountSettled
      estimateDate
      settledAt
      transactionAmount
      tryCount
      requestSettleDate
      request
      response
      result
      brokerageFee
      cardBrokerageFee
      cardBrokerageRate
      carryOrverAmount
      creditAmount
      creditBrokerageRate
      creditBrokerageFee
      billingStatus
      amountBilled
      billedAt
      billingHistoryId
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteSettlement = /* GraphQL */ `
  subscription OnDeleteSettlement {
    onDeleteSettlement {
      storeId
      transactedAt
      status
      enterpriseId
      locationId
      amount
      amountSettled
      estimateDate
      settledAt
      transactionAmount
      tryCount
      requestSettleDate
      request
      response
      result
      brokerageFee
      cardBrokerageFee
      cardBrokerageRate
      carryOrverAmount
      creditAmount
      creditBrokerageRate
      creditBrokerageFee
      billingStatus
      amountBilled
      billedAt
      billingHistoryId
      updatedAt
      createdAt
    }
  }
`;
export const onCreateRequestHistory = /* GraphQL */ `
  subscription OnCreateRequestHistory {
    onCreateRequestHistory {
      id
      headers
      ident
      audience
      path
      method
      body
      params
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onUpdateRequestHistory = /* GraphQL */ `
  subscription OnUpdateRequestHistory {
    onUpdateRequestHistory {
      id
      headers
      ident
      audience
      path
      method
      body
      params
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onDeleteRequestHistory = /* GraphQL */ `
  subscription OnDeleteRequestHistory {
    onDeleteRequestHistory {
      id
      headers
      ident
      audience
      path
      method
      body
      params
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onCreateWebhookHistory = /* GraphQL */ `
  subscription OnCreateWebhookHistory {
    onCreateWebhookHistory {
      id
      storeId
      event
      url
      payload
      referId
      responseCode
      retryCount
      errorMessage
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onUpdateWebhookHistory = /* GraphQL */ `
  subscription OnUpdateWebhookHistory {
    onUpdateWebhookHistory {
      id
      storeId
      event
      url
      payload
      referId
      responseCode
      retryCount
      errorMessage
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onDeleteWebhookHistory = /* GraphQL */ `
  subscription OnDeleteWebhookHistory {
    onDeleteWebhookHistory {
      id
      storeId
      event
      url
      payload
      referId
      responseCode
      retryCount
      errorMessage
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onCreateOrderHistory = /* GraphQL */ `
  subscription OnCreateOrderHistory {
    onCreateOrderHistory {
      storeId
      createdAt
      enterpriseId
      locationId
      type
      amount
      parentId
      currency
      orderHistoryOrderId
      customerStatus
      gender
      birth
      customerId
      updatedAt
      order {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        giftReceiverKey
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
    }
  }
`;
export const onUpdateOrderHistory = /* GraphQL */ `
  subscription OnUpdateOrderHistory {
    onUpdateOrderHistory {
      storeId
      createdAt
      enterpriseId
      locationId
      type
      amount
      parentId
      currency
      orderHistoryOrderId
      customerStatus
      gender
      birth
      customerId
      updatedAt
      order {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        giftReceiverKey
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
    }
  }
`;
export const onDeleteOrderHistory = /* GraphQL */ `
  subscription OnDeleteOrderHistory {
    onDeleteOrderHistory {
      storeId
      createdAt
      enterpriseId
      locationId
      type
      amount
      parentId
      currency
      orderHistoryOrderId
      customerStatus
      gender
      birth
      customerId
      updatedAt
      order {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        giftReceiverKey
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
    }
  }
`;
export const onCreateCustomerCart = /* GraphQL */ `
  subscription OnCreateCustomerCart {
    onCreateCustomerCart {
      id
      number
      storeId
      orderLocationId
      orderCustomerId
      state
      amount
      taxFreeAmount
      supplyAmount
      tax
      currency
      quantity
      diningOption
      diningState
      address {
        id
        main
        detail
        storeId
      }
      address1
      address2
      reserveDate
      salesDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdAt
      updatedAt
      request
      visitorCount
      pointSaved
    }
  }
`;
export const onUpdateCustomerCart = /* GraphQL */ `
  subscription OnUpdateCustomerCart {
    onUpdateCustomerCart {
      id
      number
      storeId
      orderLocationId
      orderCustomerId
      state
      amount
      taxFreeAmount
      supplyAmount
      tax
      currency
      quantity
      diningOption
      diningState
      address {
        id
        main
        detail
        storeId
      }
      address1
      address2
      reserveDate
      salesDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdAt
      updatedAt
      request
      visitorCount
      pointSaved
    }
  }
`;
export const onDeleteCustomerCart = /* GraphQL */ `
  subscription OnDeleteCustomerCart {
    onDeleteCustomerCart {
      id
      number
      storeId
      orderLocationId
      orderCustomerId
      state
      amount
      taxFreeAmount
      supplyAmount
      tax
      currency
      quantity
      diningOption
      diningState
      address {
        id
        main
        detail
        storeId
      }
      address1
      address2
      reserveDate
      salesDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdAt
      updatedAt
      request
      visitorCount
      pointSaved
    }
  }
`;
export const onCreateLink = /* GraphQL */ `
  subscription OnCreateLink {
    onCreateLink {
      id
      type
      originUrl
      redirectUrl
      parentId
      sourceId
      openedAt
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateLink = /* GraphQL */ `
  subscription OnUpdateLink {
    onUpdateLink {
      id
      type
      originUrl
      redirectUrl
      parentId
      sourceId
      openedAt
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteLink = /* GraphQL */ `
  subscription OnDeleteLink {
    onDeleteLink {
      id
      type
      originUrl
      redirectUrl
      parentId
      sourceId
      openedAt
      updatedAt
      createdAt
    }
  }
`;
export const onCreateCustomerGroup = /* GraphQL */ `
  subscription OnCreateCustomerGroup {
    onCreateCustomerGroup {
      id
      name
      type
      storeGroupsId
      locationGroupsId
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      count
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCustomerGroup = /* GraphQL */ `
  subscription OnUpdateCustomerGroup {
    onUpdateCustomerGroup {
      id
      name
      type
      storeGroupsId
      locationGroupsId
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      count
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCustomerGroup = /* GraphQL */ `
  subscription OnDeleteCustomerGroup {
    onDeleteCustomerGroup {
      id
      name
      type
      storeGroupsId
      locationGroupsId
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      count
      createdAt
      updatedAt
    }
  }
`;
export const onCreateReportHistory = /* GraphQL */ `
  subscription OnCreateReportHistory {
    onCreateReportHistory {
      id
      storeId
      type
      start
      end
      results {
        id
        phone
        resultCode
        resultCodeName
      }
      requestId
      title
      message
      error
      requestedAt
      templateId
      status
      sentAt
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateReportHistory = /* GraphQL */ `
  subscription OnUpdateReportHistory {
    onUpdateReportHistory {
      id
      storeId
      type
      start
      end
      results {
        id
        phone
        resultCode
        resultCodeName
      }
      requestId
      title
      message
      error
      requestedAt
      templateId
      status
      sentAt
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteReportHistory = /* GraphQL */ `
  subscription OnDeleteReportHistory {
    onDeleteReportHistory {
      id
      storeId
      type
      start
      end
      results {
        id
        phone
        resultCode
        resultCodeName
      }
      requestId
      title
      message
      error
      requestedAt
      templateId
      status
      sentAt
      updatedAt
      createdAt
    }
  }
`;
export const onCreateBugReport = /* GraphQL */ `
  subscription OnCreateBugReport {
    onCreateBugReport {
      id
      storeId
      employeeId
      locationId
      category
      name
      meta
      logs
      device {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onUpdateBugReport = /* GraphQL */ `
  subscription OnUpdateBugReport {
    onUpdateBugReport {
      id
      storeId
      employeeId
      locationId
      category
      name
      meta
      logs
      device {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onDeleteBugReport = /* GraphQL */ `
  subscription OnDeleteBugReport {
    onDeleteBugReport {
      id
      storeId
      employeeId
      locationId
      category
      name
      meta
      logs
      device {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onCreateEventHistory = /* GraphQL */ `
  subscription OnCreateEventHistory {
    onCreateEventHistory {
      id
      storeId
      employeeId
      locationId
      category
      device {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onUpdateEventHistory = /* GraphQL */ `
  subscription OnUpdateEventHistory {
    onUpdateEventHistory {
      id
      storeId
      employeeId
      locationId
      category
      device {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onDeleteEventHistory = /* GraphQL */ `
  subscription OnDeleteEventHistory {
    onDeleteEventHistory {
      id
      storeId
      employeeId
      locationId
      category
      device {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onCreateCouponDelta = /* GraphQL */ `
  subscription OnCreateCouponDelta {
    onCreateCouponDelta {
      id
      storeId
      enterpriseId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      name
      description
      availableOrigins
      code
      type
      method
      tranCount
      generateCount
      publishCount
      limitPublishCount
      duplicatePublish
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionItemsOperator
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      referId
      validDateType
      validValue
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      notice
      pointSavable
      startedAt
      endedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdateCouponDelta = /* GraphQL */ `
  subscription OnUpdateCouponDelta {
    onUpdateCouponDelta {
      id
      storeId
      enterpriseId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      name
      description
      availableOrigins
      code
      type
      method
      tranCount
      generateCount
      publishCount
      limitPublishCount
      duplicatePublish
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionItemsOperator
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      referId
      validDateType
      validValue
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      notice
      pointSavable
      startedAt
      endedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onDeleteCouponDelta = /* GraphQL */ `
  subscription OnDeleteCouponDelta {
    onDeleteCouponDelta {
      id
      storeId
      enterpriseId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      name
      description
      availableOrigins
      code
      type
      method
      tranCount
      generateCount
      publishCount
      limitPublishCount
      duplicatePublish
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionItemsOperator
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      referId
      validDateType
      validValue
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      notice
      pointSavable
      startedAt
      endedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onCreateCampaignResult = /* GraphQL */ `
  subscription OnCreateCampaignResult {
    onCreateCampaignResult {
      id
      enterpriseId
      storeId
      locationId
      customerId
      campaignResultCustomerId
      customerProvider
      providerCustomerId
      linkId
      requestId
      title
      message
      phone
      msgStatus
      reservedAt
      campaignResultsId
      requestedAt
      resultCode
      resultCodeName
      templateId
      statusCode
      method
      sendType
      sender
      sentAt
      creditTransactionId
      messageType
      failureReason
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateCampaignResult = /* GraphQL */ `
  subscription OnUpdateCampaignResult {
    onUpdateCampaignResult {
      id
      enterpriseId
      storeId
      locationId
      customerId
      campaignResultCustomerId
      customerProvider
      providerCustomerId
      linkId
      requestId
      title
      message
      phone
      msgStatus
      reservedAt
      campaignResultsId
      requestedAt
      resultCode
      resultCodeName
      templateId
      statusCode
      method
      sendType
      sender
      sentAt
      creditTransactionId
      messageType
      failureReason
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteCampaignResult = /* GraphQL */ `
  subscription OnDeleteCampaignResult {
    onDeleteCampaignResult {
      id
      enterpriseId
      storeId
      locationId
      customerId
      campaignResultCustomerId
      customerProvider
      providerCustomerId
      linkId
      requestId
      title
      message
      phone
      msgStatus
      reservedAt
      campaignResultsId
      requestedAt
      resultCode
      resultCodeName
      templateId
      statusCode
      method
      sendType
      sender
      sentAt
      creditTransactionId
      messageType
      failureReason
      updatedAt
      createdAt
    }
  }
`;
export const onCreateCampaignTemplate = /* GraphQL */ `
  subscription OnCreateCampaignTemplate {
    onCreateCampaignTemplate {
      id
      storeId
      locationId
      ads
      name
      title
      message
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateCampaignTemplate = /* GraphQL */ `
  subscription OnUpdateCampaignTemplate {
    onUpdateCampaignTemplate {
      id
      storeId
      locationId
      ads
      name
      title
      message
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteCampaignTemplate = /* GraphQL */ `
  subscription OnDeleteCampaignTemplate {
    onDeleteCampaignTemplate {
      id
      storeId
      locationId
      ads
      name
      title
      message
      updatedAt
      createdAt
    }
  }
`;
export const onCreateCampaign = /* GraphQL */ `
  subscription OnCreateCampaign {
    onCreateCampaign {
      id
      enterpriseId
      storeId
      locationId
      type
      name
      trigger
      agency
      triggerTiming
      triggerCondition {
        type
        operation
        value
      }
      startDate
      endDate
      couponProvider
      couponId
      description
      recipientProvider
      recipientId
      campaignRecipientId
      recipient {
        id
        name
        type
        storeGroupsId
        locationGroupsId
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        count
        createdAt
        updatedAt
      }
      campaignRecipientTagId
      campaignRecipientLocationIds
      recipientList
      recipientCount
      filter {
        type
        operation
        value
      }
      includes
      sendNow
      sendAfterDays
      sendAtTime
      reserveDate
      sentAt
      title
      message
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      imageType
      imageLink
      buttons {
        order
        type
        name
        linkMo
        linkPc
        target
      }
      params {
        key
        value
      }
      templateCode
      templateId
      method
      tracking
      trackingLink
      block
      ads
      duplicatable
      sender
      success
      failure
      pending
      cost
      status
      creditTransactionId
      results {
        items {
          id
          enterpriseId
          storeId
          locationId
          customerId
          campaignResultCustomerId
          customerProvider
          providerCustomerId
          linkId
          requestId
          title
          message
          phone
          msgStatus
          reservedAt
          campaignResultsId
          requestedAt
          resultCode
          resultCodeName
          templateId
          statusCode
          method
          sendType
          sender
          sentAt
          creditTransactionId
          messageType
          failureReason
          updatedAt
          createdAt
        }
        nextToken
      }
      updatedAt
      createdAt
      report
      system
      messageType
      sendTarget
      brandMessageType
      listItems
      cards
      tail
      brandImages
      coupon
      recipientTag {
        id
        label
        description
        color
        customerIds
        storeId
        locationId
        type
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
      }
    }
  }
`;
export const onUpdateCampaign = /* GraphQL */ `
  subscription OnUpdateCampaign {
    onUpdateCampaign {
      id
      enterpriseId
      storeId
      locationId
      type
      name
      trigger
      agency
      triggerTiming
      triggerCondition {
        type
        operation
        value
      }
      startDate
      endDate
      couponProvider
      couponId
      description
      recipientProvider
      recipientId
      campaignRecipientId
      recipient {
        id
        name
        type
        storeGroupsId
        locationGroupsId
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        count
        createdAt
        updatedAt
      }
      campaignRecipientTagId
      campaignRecipientLocationIds
      recipientList
      recipientCount
      filter {
        type
        operation
        value
      }
      includes
      sendNow
      sendAfterDays
      sendAtTime
      reserveDate
      sentAt
      title
      message
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      imageType
      imageLink
      buttons {
        order
        type
        name
        linkMo
        linkPc
        target
      }
      params {
        key
        value
      }
      templateCode
      templateId
      method
      tracking
      trackingLink
      block
      ads
      duplicatable
      sender
      success
      failure
      pending
      cost
      status
      creditTransactionId
      results {
        items {
          id
          enterpriseId
          storeId
          locationId
          customerId
          campaignResultCustomerId
          customerProvider
          providerCustomerId
          linkId
          requestId
          title
          message
          phone
          msgStatus
          reservedAt
          campaignResultsId
          requestedAt
          resultCode
          resultCodeName
          templateId
          statusCode
          method
          sendType
          sender
          sentAt
          creditTransactionId
          messageType
          failureReason
          updatedAt
          createdAt
        }
        nextToken
      }
      updatedAt
      createdAt
      report
      system
      messageType
      sendTarget
      brandMessageType
      listItems
      cards
      tail
      brandImages
      coupon
      recipientTag {
        id
        label
        description
        color
        customerIds
        storeId
        locationId
        type
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
      }
    }
  }
`;
export const onDeleteCampaign = /* GraphQL */ `
  subscription OnDeleteCampaign {
    onDeleteCampaign {
      id
      enterpriseId
      storeId
      locationId
      type
      name
      trigger
      agency
      triggerTiming
      triggerCondition {
        type
        operation
        value
      }
      startDate
      endDate
      couponProvider
      couponId
      description
      recipientProvider
      recipientId
      campaignRecipientId
      recipient {
        id
        name
        type
        storeGroupsId
        locationGroupsId
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        count
        createdAt
        updatedAt
      }
      campaignRecipientTagId
      campaignRecipientLocationIds
      recipientList
      recipientCount
      filter {
        type
        operation
        value
      }
      includes
      sendNow
      sendAfterDays
      sendAtTime
      reserveDate
      sentAt
      title
      message
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      imageType
      imageLink
      buttons {
        order
        type
        name
        linkMo
        linkPc
        target
      }
      params {
        key
        value
      }
      templateCode
      templateId
      method
      tracking
      trackingLink
      block
      ads
      duplicatable
      sender
      success
      failure
      pending
      cost
      status
      creditTransactionId
      results {
        items {
          id
          enterpriseId
          storeId
          locationId
          customerId
          campaignResultCustomerId
          customerProvider
          providerCustomerId
          linkId
          requestId
          title
          message
          phone
          msgStatus
          reservedAt
          campaignResultsId
          requestedAt
          resultCode
          resultCodeName
          templateId
          statusCode
          method
          sendType
          sender
          sentAt
          creditTransactionId
          messageType
          failureReason
          updatedAt
          createdAt
        }
        nextToken
      }
      updatedAt
      createdAt
      report
      system
      messageType
      sendTarget
      brandMessageType
      listItems
      cards
      tail
      brandImages
      coupon
      recipientTag {
        id
        label
        description
        color
        customerIds
        storeId
        locationId
        type
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
      }
    }
  }
`;
export const onCreateInventoryAdjustmentTask = /* GraphQL */ `
  subscription OnCreateInventoryAdjustmentTask {
    onCreateInventoryAdjustmentTask {
      id
      type
      storeId
      locationId
      productId
      reason
      setId
      skuId
      quantity
      employeeId
      cost
      expiryDate
      note
      origin
      readyQuantity
      unavailableQuantity
      adjustedAt
      groupId
      referId
      syncHistoryId
      purchaseOrderId
      transferHistoryId
      countHistoryId
      historyId
      eventId
      index
      count
      doneAt
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onUpdateInventoryAdjustmentTask = /* GraphQL */ `
  subscription OnUpdateInventoryAdjustmentTask {
    onUpdateInventoryAdjustmentTask {
      id
      type
      storeId
      locationId
      productId
      reason
      setId
      skuId
      quantity
      employeeId
      cost
      expiryDate
      note
      origin
      readyQuantity
      unavailableQuantity
      adjustedAt
      groupId
      referId
      syncHistoryId
      purchaseOrderId
      transferHistoryId
      countHistoryId
      historyId
      eventId
      index
      count
      doneAt
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onDeleteInventoryAdjustmentTask = /* GraphQL */ `
  subscription OnDeleteInventoryAdjustmentTask {
    onDeleteInventoryAdjustmentTask {
      id
      type
      storeId
      locationId
      productId
      reason
      setId
      skuId
      quantity
      employeeId
      cost
      expiryDate
      note
      origin
      readyQuantity
      unavailableQuantity
      adjustedAt
      groupId
      referId
      syncHistoryId
      purchaseOrderId
      transferHistoryId
      countHistoryId
      historyId
      eventId
      index
      count
      doneAt
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onCreateInventoryHistory = /* GraphQL */ `
  subscription OnCreateInventoryHistory {
    onCreateInventoryHistory {
      id
      createdAt
      enterpriseId
      storeId
      productId
      skuId
      locationId
      employeeId
      inventoryId
      referId
      referOrderOrigin
      origin
      groupId
      groupHistoryCount
      purchaseOrderId
      totalCost
      cost
      expiryDate
      note
      reason
      transactions {
        parentId
        reason
        quantity
        prevQuantity
        createdAt
      }
      quantity
      prevQuantity
      currQuantity
      readyQuantity
      updatedAt
    }
  }
`;
export const onUpdateInventoryHistory = /* GraphQL */ `
  subscription OnUpdateInventoryHistory {
    onUpdateInventoryHistory {
      id
      createdAt
      enterpriseId
      storeId
      productId
      skuId
      locationId
      employeeId
      inventoryId
      referId
      referOrderOrigin
      origin
      groupId
      groupHistoryCount
      purchaseOrderId
      totalCost
      cost
      expiryDate
      note
      reason
      transactions {
        parentId
        reason
        quantity
        prevQuantity
        createdAt
      }
      quantity
      prevQuantity
      currQuantity
      readyQuantity
      updatedAt
    }
  }
`;
export const onDeleteInventoryHistory = /* GraphQL */ `
  subscription OnDeleteInventoryHistory {
    onDeleteInventoryHistory {
      id
      createdAt
      enterpriseId
      storeId
      productId
      skuId
      locationId
      employeeId
      inventoryId
      referId
      referOrderOrigin
      origin
      groupId
      groupHistoryCount
      purchaseOrderId
      totalCost
      cost
      expiryDate
      note
      reason
      transactions {
        parentId
        reason
        quantity
        prevQuantity
        createdAt
      }
      quantity
      prevQuantity
      currQuantity
      readyQuantity
      updatedAt
    }
  }
`;
export const onCreateInventoryQuantity = /* GraphQL */ `
  subscription OnCreateInventoryQuantity {
    onCreateInventoryQuantity {
      id
      inventoryId
      storeId
      locationId
      productId
      skuId
      quantity
      lastTransaction {
        parentId
        reason
        quantity
        prevQuantity
        createdAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateInventoryQuantity = /* GraphQL */ `
  subscription OnUpdateInventoryQuantity {
    onUpdateInventoryQuantity {
      id
      inventoryId
      storeId
      locationId
      productId
      skuId
      quantity
      lastTransaction {
        parentId
        reason
        quantity
        prevQuantity
        createdAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteInventoryQuantity = /* GraphQL */ `
  subscription OnDeleteInventoryQuantity {
    onDeleteInventoryQuantity {
      id
      inventoryId
      storeId
      locationId
      productId
      skuId
      quantity
      lastTransaction {
        parentId
        reason
        quantity
        prevQuantity
        createdAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateInventory = /* GraphQL */ `
  subscription OnCreateInventory {
    onCreateInventory {
      id
      storeId
      productId
      skuId
      expiryDate
      attributes {
        name
        type
        value
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateInventory = /* GraphQL */ `
  subscription OnUpdateInventory {
    onUpdateInventory {
      id
      storeId
      productId
      skuId
      expiryDate
      attributes {
        name
        type
        value
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteInventory = /* GraphQL */ `
  subscription OnDeleteInventory {
    onDeleteInventory {
      id
      storeId
      productId
      skuId
      expiryDate
      attributes {
        name
        type
        value
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateStoreProducts = /* GraphQL */ `
  subscription OnCreateStoreProducts {
    onCreateStoreProducts {
      id
      categories {
        items {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
      modifiers {
        items {
          id
          type
          enterpriseId
          storeId
          name
          nameMl {
            en
            zh
            ja
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          origin
          orderType
          defaultSkuId
          coverage
          required
          requiredQuantity
          limitQuantity
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
      updatedAt
      createdAt
      products {
        items {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateStoreProducts = /* GraphQL */ `
  subscription OnUpdateStoreProducts {
    onUpdateStoreProducts {
      id
      categories {
        items {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
      modifiers {
        items {
          id
          type
          enterpriseId
          storeId
          name
          nameMl {
            en
            zh
            ja
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          origin
          orderType
          defaultSkuId
          coverage
          required
          requiredQuantity
          limitQuantity
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
      updatedAt
      createdAt
      products {
        items {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteStoreProducts = /* GraphQL */ `
  subscription OnDeleteStoreProducts {
    onDeleteStoreProducts {
      id
      categories {
        items {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
      modifiers {
        items {
          id
          type
          enterpriseId
          storeId
          name
          nameMl {
            en
            zh
            ja
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          origin
          orderType
          defaultSkuId
          coverage
          required
          requiredQuantity
          limitQuantity
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
      updatedAt
      createdAt
      products {
        items {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateCategory = /* GraphQL */ `
  subscription OnCreateCategory {
    onCreateCategory {
      type
      id
      code
      enterpriseId
      storeId
      name
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      depth
      parentCategoryId
      active
      refer
      referId
      sortKey
      subCategoryProductDisplay
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateCategory = /* GraphQL */ `
  subscription OnUpdateCategory {
    onUpdateCategory {
      type
      id
      code
      enterpriseId
      storeId
      name
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      depth
      parentCategoryId
      active
      refer
      referId
      sortKey
      subCategoryProductDisplay
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteCategory = /* GraphQL */ `
  subscription OnDeleteCategory {
    onDeleteCategory {
      type
      id
      code
      enterpriseId
      storeId
      name
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      depth
      parentCategoryId
      active
      refer
      referId
      sortKey
      subCategoryProductDisplay
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onCreateClassification = /* GraphQL */ `
  subscription OnCreateClassification {
    onCreateClassification {
      type
      id
      enterpriseId
      storeId
      name
      depth
      parentId
      refer
      referId
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateClassification = /* GraphQL */ `
  subscription OnUpdateClassification {
    onUpdateClassification {
      type
      id
      enterpriseId
      storeId
      name
      depth
      parentId
      refer
      referId
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteClassification = /* GraphQL */ `
  subscription OnDeleteClassification {
    onDeleteClassification {
      type
      id
      enterpriseId
      storeId
      name
      depth
      parentId
      refer
      referId
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateModifier = /* GraphQL */ `
  subscription OnCreateModifier {
    onCreateModifier {
      id
      type
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      origin
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateModifier = /* GraphQL */ `
  subscription OnUpdateModifier {
    onUpdateModifier {
      id
      type
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      origin
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteModifier = /* GraphQL */ `
  subscription OnDeleteModifier {
    onDeleteModifier {
      id
      type
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      origin
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onCreateProductCategory = /* GraphQL */ `
  subscription OnCreateProductCategory {
    onCreateProductCategory {
      id
      enterpriseId
      storeId
      productId
      categoryId
      position
      category {
        type
        id
        code
        enterpriseId
        storeId
        name
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        depth
        parentCategoryId
        active
        refer
        referId
        sortKey
        subCategoryProductDisplay
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onUpdateProductCategory = /* GraphQL */ `
  subscription OnUpdateProductCategory {
    onUpdateProductCategory {
      id
      enterpriseId
      storeId
      productId
      categoryId
      position
      category {
        type
        id
        code
        enterpriseId
        storeId
        name
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        depth
        parentCategoryId
        active
        refer
        referId
        sortKey
        subCategoryProductDisplay
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onDeleteProductCategory = /* GraphQL */ `
  subscription OnDeleteProductCategory {
    onDeleteProductCategory {
      id
      enterpriseId
      storeId
      productId
      categoryId
      position
      category {
        type
        id
        code
        enterpriseId
        storeId
        name
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        depth
        parentCategoryId
        active
        refer
        referId
        sortKey
        subCategoryProductDisplay
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onCreateProductClassification = /* GraphQL */ `
  subscription OnCreateProductClassification {
    onCreateProductClassification {
      id
      enterpriseId
      storeId
      productId
      classificationId
      classification {
        type
        id
        code
        enterpriseId
        storeId
        name
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        depth
        parentCategoryId
        active
        refer
        referId
        sortKey
        subCategoryProductDisplay
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onUpdateProductClassification = /* GraphQL */ `
  subscription OnUpdateProductClassification {
    onUpdateProductClassification {
      id
      enterpriseId
      storeId
      productId
      classificationId
      classification {
        type
        id
        code
        enterpriseId
        storeId
        name
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        depth
        parentCategoryId
        active
        refer
        referId
        sortKey
        subCategoryProductDisplay
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onDeleteProductClassification = /* GraphQL */ `
  subscription OnDeleteProductClassification {
    onDeleteProductClassification {
      id
      enterpriseId
      storeId
      productId
      classificationId
      classification {
        type
        id
        code
        enterpriseId
        storeId
        name
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        depth
        parentCategoryId
        active
        refer
        referId
        sortKey
        subCategoryProductDisplay
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onCreateProductModifier = /* GraphQL */ `
  subscription OnCreateProductModifier {
    onCreateProductModifier {
      id
      enterpriseId
      storeId
      productId
      modifierId
      position
      modifier {
        id
        type
        enterpriseId
        storeId
        name
        nameMl {
          en
          zh
          ja
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        origin
        orderType
        defaultSkuId
        coverage
        required
        requiredQuantity
        limitQuantity
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onUpdateProductModifier = /* GraphQL */ `
  subscription OnUpdateProductModifier {
    onUpdateProductModifier {
      id
      enterpriseId
      storeId
      productId
      modifierId
      position
      modifier {
        id
        type
        enterpriseId
        storeId
        name
        nameMl {
          en
          zh
          ja
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        origin
        orderType
        defaultSkuId
        coverage
        required
        requiredQuantity
        limitQuantity
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onDeleteProductModifier = /* GraphQL */ `
  subscription OnDeleteProductModifier {
    onDeleteProductModifier {
      id
      enterpriseId
      storeId
      productId
      modifierId
      position
      modifier {
        id
        type
        enterpriseId
        storeId
        name
        nameMl {
          en
          zh
          ja
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        origin
        orderType
        defaultSkuId
        coverage
        required
        requiredQuantity
        limitQuantity
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onCreateSalesHistory = /* GraphQL */ `
  subscription OnCreateSalesHistory {
    onCreateSalesHistory {
      storeId
      startedAt
      enterpriseId
      locationId
      endedAt
      reserves
      actualBalance
      currency
      note
      estimateBalance
      cashes {
        name
        value
        count
      }
      reservesHistories {
        type
        amount
        note
        createdEmployeeId
        createdAt
      }
      detail {
        totalSales
        totalRefund
        totalTax
        totalDiscount
        supplyAmount
        totalSalesCount
        cash {
          sales
          refund
        }
        card {
          sales
          refund
        }
        credit {
          sales
          refund
        }
        barcode {
          sales
          refund
        }
        extra {
          sales
          refund
        }
        refund {
          sales
          refund
        }
        products {
          id
          name
          quantity
          amount
        }
        origins {
          pos
          kiosk
          menuorder
          delivery
          market
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateSalesHistory = /* GraphQL */ `
  subscription OnUpdateSalesHistory {
    onUpdateSalesHistory {
      storeId
      startedAt
      enterpriseId
      locationId
      endedAt
      reserves
      actualBalance
      currency
      note
      estimateBalance
      cashes {
        name
        value
        count
      }
      reservesHistories {
        type
        amount
        note
        createdEmployeeId
        createdAt
      }
      detail {
        totalSales
        totalRefund
        totalTax
        totalDiscount
        supplyAmount
        totalSalesCount
        cash {
          sales
          refund
        }
        card {
          sales
          refund
        }
        credit {
          sales
          refund
        }
        barcode {
          sales
          refund
        }
        extra {
          sales
          refund
        }
        refund {
          sales
          refund
        }
        products {
          id
          name
          quantity
          amount
        }
        origins {
          pos
          kiosk
          menuorder
          delivery
          market
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteSalesHistory = /* GraphQL */ `
  subscription OnDeleteSalesHistory {
    onDeleteSalesHistory {
      storeId
      startedAt
      enterpriseId
      locationId
      endedAt
      reserves
      actualBalance
      currency
      note
      estimateBalance
      cashes {
        name
        value
        count
      }
      reservesHistories {
        type
        amount
        note
        createdEmployeeId
        createdAt
      }
      detail {
        totalSales
        totalRefund
        totalTax
        totalDiscount
        supplyAmount
        totalSalesCount
        cash {
          sales
          refund
        }
        card {
          sales
          refund
        }
        credit {
          sales
          refund
        }
        barcode {
          sales
          refund
        }
        extra {
          sales
          refund
        }
        refund {
          sales
          refund
        }
        products {
          id
          name
          quantity
          amount
        }
        origins {
          pos
          kiosk
          menuorder
          delivery
          market
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateGlobalDelta = /* GraphQL */ `
  subscription OnCreateGlobalDelta {
    onCreateGlobalDelta {
      id
      type
      storeId
      locationId
      data
      updatedAt
      createdAt
      timestamp
      expdate
    }
  }
`;
export const onUpdateGlobalDelta = /* GraphQL */ `
  subscription OnUpdateGlobalDelta {
    onUpdateGlobalDelta {
      id
      type
      storeId
      locationId
      data
      updatedAt
      createdAt
      timestamp
      expdate
    }
  }
`;
export const onDeleteGlobalDelta = /* GraphQL */ `
  subscription OnDeleteGlobalDelta {
    onDeleteGlobalDelta {
      id
      type
      storeId
      locationId
      data
      updatedAt
      createdAt
      timestamp
      expdate
    }
  }
`;
export const onCreateBillHistory = /* GraphQL */ `
  subscription OnCreateBillHistory {
    onCreateBillHistory {
      id
      date
      storeId
      locationId
      name
      type
      status
      failReason
      discounts {
        name
        amount
        transactionId
      }
      amount
      currency
      paidAt
      refundedAt
      transaction {
        cardName
        cardNumber
        cardQuota
        pg
        transactionId
        amount
        currency
        method
        purchasedAt
        requestedAt
        revokedAt
        status
        statusEn
        statusKo
        receiptId
        receiptUrl
      }
      items {
        type
        name
        amount
        details {
          type
          name
          amount
          basePrice
          unitPrice
          usage
          rate
          referId
          period
        }
      }
      note
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateBillHistory = /* GraphQL */ `
  subscription OnUpdateBillHistory {
    onUpdateBillHistory {
      id
      date
      storeId
      locationId
      name
      type
      status
      failReason
      discounts {
        name
        amount
        transactionId
      }
      amount
      currency
      paidAt
      refundedAt
      transaction {
        cardName
        cardNumber
        cardQuota
        pg
        transactionId
        amount
        currency
        method
        purchasedAt
        requestedAt
        revokedAt
        status
        statusEn
        statusKo
        receiptId
        receiptUrl
      }
      items {
        type
        name
        amount
        details {
          type
          name
          amount
          basePrice
          unitPrice
          usage
          rate
          referId
          period
        }
      }
      note
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteBillHistory = /* GraphQL */ `
  subscription OnDeleteBillHistory {
    onDeleteBillHistory {
      id
      date
      storeId
      locationId
      name
      type
      status
      failReason
      discounts {
        name
        amount
        transactionId
      }
      amount
      currency
      paidAt
      refundedAt
      transaction {
        cardName
        cardNumber
        cardQuota
        pg
        transactionId
        amount
        currency
        method
        purchasedAt
        requestedAt
        revokedAt
        status
        statusEn
        statusKo
        receiptId
        receiptUrl
      }
      items {
        type
        name
        amount
        details {
          type
          name
          amount
          basePrice
          unitPrice
          usage
          rate
          referId
          period
        }
      }
      note
      updatedAt
      createdAt
    }
  }
`;
export const onCreateBillingHistory = /* GraphQL */ `
  subscription OnCreateBillingHistory {
    onCreateBillingHistory {
      id
      date
      enterpriseId
      storeId
      locationId
      name
      type
      status
      failReason
      amount
      currency
      paidAt
      refundedAt
      transaction {
        cardName
        cardNumber
        cardQuota
        pg
        transactionId
        amount
        currency
        method
        purchasedAt
        requestedAt
        revokedAt
        status
        statusEn
        statusKo
        receiptId
        receiptUrl
      }
      items {
        locationId
        name
        type
        amount
        details {
          type
          name
          amount
          basePrice
          unitPrice
          usage
          rate
          referId
          period
        }
        category
        quantity
        currency
      }
      note
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateBillingHistory = /* GraphQL */ `
  subscription OnUpdateBillingHistory {
    onUpdateBillingHistory {
      id
      date
      enterpriseId
      storeId
      locationId
      name
      type
      status
      failReason
      amount
      currency
      paidAt
      refundedAt
      transaction {
        cardName
        cardNumber
        cardQuota
        pg
        transactionId
        amount
        currency
        method
        purchasedAt
        requestedAt
        revokedAt
        status
        statusEn
        statusKo
        receiptId
        receiptUrl
      }
      items {
        locationId
        name
        type
        amount
        details {
          type
          name
          amount
          basePrice
          unitPrice
          usage
          rate
          referId
          period
        }
        category
        quantity
        currency
      }
      note
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteBillingHistory = /* GraphQL */ `
  subscription OnDeleteBillingHistory {
    onDeleteBillingHistory {
      id
      date
      enterpriseId
      storeId
      locationId
      name
      type
      status
      failReason
      amount
      currency
      paidAt
      refundedAt
      transaction {
        cardName
        cardNumber
        cardQuota
        pg
        transactionId
        amount
        currency
        method
        purchasedAt
        requestedAt
        revokedAt
        status
        statusEn
        statusKo
        receiptId
        receiptUrl
      }
      items {
        locationId
        name
        type
        amount
        details {
          type
          name
          amount
          basePrice
          unitPrice
          usage
          rate
          referId
          period
        }
        category
        quantity
        currency
      }
      note
      updatedAt
      createdAt
    }
  }
`;
export const onCreateLabelTemplate = /* GraphQL */ `
  subscription OnCreateLabelTemplate {
    onCreateLabelTemplate {
      id
      storeId
      locationId
      name
      components {
        type
        format
        height
        fontSize
        maxLines
        align
        bold
        strikeThrough
        showText
        x
        y
        w
        h
        discountRule
      }
      pageLayout {
        horizontalCount
        width
        height
        marginRight
        marginTop
        marginLeft
        marginBottom
        templateWidth
        templateHeight
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateLabelTemplate = /* GraphQL */ `
  subscription OnUpdateLabelTemplate {
    onUpdateLabelTemplate {
      id
      storeId
      locationId
      name
      components {
        type
        format
        height
        fontSize
        maxLines
        align
        bold
        strikeThrough
        showText
        x
        y
        w
        h
        discountRule
      }
      pageLayout {
        horizontalCount
        width
        height
        marginRight
        marginTop
        marginLeft
        marginBottom
        templateWidth
        templateHeight
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteLabelTemplate = /* GraphQL */ `
  subscription OnDeleteLabelTemplate {
    onDeleteLabelTemplate {
      id
      storeId
      locationId
      name
      components {
        type
        format
        height
        fontSize
        maxLines
        align
        bold
        strikeThrough
        showText
        x
        y
        w
        h
        discountRule
      }
      pageLayout {
        horizontalCount
        width
        height
        marginRight
        marginTop
        marginLeft
        marginBottom
        templateWidth
        templateHeight
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage {
    onCreateMessage {
      id
      enterpriseId
      storeId
      locationId
      priority
      read
      type
      title
      body
      action {
        category
        method
        args
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage {
    onUpdateMessage {
      id
      enterpriseId
      storeId
      locationId
      priority
      read
      type
      title
      body
      action {
        category
        method
        args
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage {
    onDeleteMessage {
      id
      enterpriseId
      storeId
      locationId
      priority
      read
      type
      title
      body
      action {
        category
        method
        args
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateCafe24Auth = /* GraphQL */ `
  subscription OnCreateCafe24Auth {
    onCreateCafe24Auth {
      id
      storeId
      accessToken
      accessTokenExpiredAt
      refreshToken
      refreshToeknExpiredAt
      clientId
      userId
      scopes
      issuedAt
      shopNumber
      token1
      token2
      token3
      trialExpiredAt
      session {
        status
        cookies
        capturedAt
        lastVerifiedAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateCafe24Auth = /* GraphQL */ `
  subscription OnUpdateCafe24Auth {
    onUpdateCafe24Auth {
      id
      storeId
      accessToken
      accessTokenExpiredAt
      refreshToken
      refreshToeknExpiredAt
      clientId
      userId
      scopes
      issuedAt
      shopNumber
      token1
      token2
      token3
      trialExpiredAt
      session {
        status
        cookies
        capturedAt
        lastVerifiedAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteCafe24Auth = /* GraphQL */ `
  subscription OnDeleteCafe24Auth {
    onDeleteCafe24Auth {
      id
      storeId
      accessToken
      accessTokenExpiredAt
      refreshToken
      refreshToeknExpiredAt
      clientId
      userId
      scopes
      issuedAt
      shopNumber
      token1
      token2
      token3
      trialExpiredAt
      session {
        status
        cookies
        capturedAt
        lastVerifiedAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateCafe24Event = /* GraphQL */ `
  subscription OnCreateCafe24Event {
    onCreateCafe24Event {
      id
      number
      resource
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateCafe24Event = /* GraphQL */ `
  subscription OnUpdateCafe24Event {
    onUpdateCafe24Event {
      id
      number
      resource
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteCafe24Event = /* GraphQL */ `
  subscription OnDeleteCafe24Event {
    onDeleteCafe24Event {
      id
      number
      resource
      updatedAt
      createdAt
    }
  }
`;
export const onCreateProviderWebhookEvent = /* GraphQL */ `
  subscription OnCreateProviderWebhookEvent {
    onCreateProviderWebhookEvent {
      id
      provider
      providerId
      type
      resource
      isSkip
      duration
      completedAt
      groupId
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onUpdateProviderWebhookEvent = /* GraphQL */ `
  subscription OnUpdateProviderWebhookEvent {
    onUpdateProviderWebhookEvent {
      id
      provider
      providerId
      type
      resource
      isSkip
      duration
      completedAt
      groupId
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onDeleteProviderWebhookEvent = /* GraphQL */ `
  subscription OnDeleteProviderWebhookEvent {
    onDeleteProviderWebhookEvent {
      id
      provider
      providerId
      type
      resource
      isSkip
      duration
      completedAt
      groupId
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const onCreateItemLinkHistory = /* GraphQL */ `
  subscription OnCreateItemLinkHistory {
    onCreateItemLinkHistory {
      id
      storeId
      type
      subType
      provider
      linkQuantity
      syncQuantity
      unlinkQuantity
      totalLinkQuantity
      employeeId
      condition
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateItemLinkHistory = /* GraphQL */ `
  subscription OnUpdateItemLinkHistory {
    onUpdateItemLinkHistory {
      id
      storeId
      type
      subType
      provider
      linkQuantity
      syncQuantity
      unlinkQuantity
      totalLinkQuantity
      employeeId
      condition
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteItemLinkHistory = /* GraphQL */ `
  subscription OnDeleteItemLinkHistory {
    onDeleteItemLinkHistory {
      id
      storeId
      type
      subType
      provider
      linkQuantity
      syncQuantity
      unlinkQuantity
      totalLinkQuantity
      employeeId
      condition
      updatedAt
      createdAt
    }
  }
`;
export const onCreateCustomerTierUpdateHistory = /* GraphQL */ `
  subscription OnCreateCustomerTierUpdateHistory {
    onCreateCustomerTierUpdateHistory {
      id
      storeId
      type
      date
      totalCount
      upCount
      downCount
      coupons {
        couponId
        count
        type
        scope
        name
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateCustomerTierUpdateHistory = /* GraphQL */ `
  subscription OnUpdateCustomerTierUpdateHistory {
    onUpdateCustomerTierUpdateHistory {
      id
      storeId
      type
      date
      totalCount
      upCount
      downCount
      coupons {
        couponId
        count
        type
        scope
        name
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteCustomerTierUpdateHistory = /* GraphQL */ `
  subscription OnDeleteCustomerTierUpdateHistory {
    onDeleteCustomerTierUpdateHistory {
      id
      storeId
      type
      date
      totalCount
      upCount
      downCount
      coupons {
        couponId
        count
        type
        scope
        name
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateStoreCafe24Config = /* GraphQL */ `
  subscription OnCreateStoreCafe24Config {
    onCreateStoreCafe24Config {
      id
      usableCouponIds
      autoTier {
        active
        tiers {
          tierId
          name
          coupons {
            id
            type
            issueScope
            name
            discountMethod
            discountValue
            conditionMinAmount
            usablePos
          }
          minAmount
          maxAmount
        }
        interval
        intervalValue
        orderPeriod
        exceptionTierIds
        calculateType
        launchDate
        promotionIntervalValue
        promotionLaunchDate
        couponIntervalValue
      }
      admins {
        name
        phone
        email
      }
      inventory {
        includeLocationIds
        excludeLocationIds
        design {
          pointColor
        }
        scope
        includeProductCode
        excludeProductCode
        searchType
        quantityType
        quantityPoint
        locationInfos {
          locationId
          name
          mapUrl
          phone
          address
          businessHours
          items
        }
        includeInventories {
          skuId
          model
        }
        excludeInventories {
          skuId
          model
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateStoreCafe24Config = /* GraphQL */ `
  subscription OnUpdateStoreCafe24Config {
    onUpdateStoreCafe24Config {
      id
      usableCouponIds
      autoTier {
        active
        tiers {
          tierId
          name
          coupons {
            id
            type
            issueScope
            name
            discountMethod
            discountValue
            conditionMinAmount
            usablePos
          }
          minAmount
          maxAmount
        }
        interval
        intervalValue
        orderPeriod
        exceptionTierIds
        calculateType
        launchDate
        promotionIntervalValue
        promotionLaunchDate
        couponIntervalValue
      }
      admins {
        name
        phone
        email
      }
      inventory {
        includeLocationIds
        excludeLocationIds
        design {
          pointColor
        }
        scope
        includeProductCode
        excludeProductCode
        searchType
        quantityType
        quantityPoint
        locationInfos {
          locationId
          name
          mapUrl
          phone
          address
          businessHours
          items
        }
        includeInventories {
          skuId
          model
        }
        excludeInventories {
          skuId
          model
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteStoreCafe24Config = /* GraphQL */ `
  subscription OnDeleteStoreCafe24Config {
    onDeleteStoreCafe24Config {
      id
      usableCouponIds
      autoTier {
        active
        tiers {
          tierId
          name
          coupons {
            id
            type
            issueScope
            name
            discountMethod
            discountValue
            conditionMinAmount
            usablePos
          }
          minAmount
          maxAmount
        }
        interval
        intervalValue
        orderPeriod
        exceptionTierIds
        calculateType
        launchDate
        promotionIntervalValue
        promotionLaunchDate
        couponIntervalValue
      }
      admins {
        name
        phone
        email
      }
      inventory {
        includeLocationIds
        excludeLocationIds
        design {
          pointColor
        }
        scope
        includeProductCode
        excludeProductCode
        searchType
        quantityType
        quantityPoint
        locationInfos {
          locationId
          name
          mapUrl
          phone
          address
          businessHours
          items
        }
        includeInventories {
          skuId
          model
        }
        excludeInventories {
          skuId
          model
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateEmployee = /* GraphQL */ `
  subscription OnCreateEmployee {
    onCreateEmployee {
      id
      role
      lastName
      firstName
      name
      nickname
      phone
      email
      employeeStoreId
      employeeEnterpriseId
      organizations {
        items {
          id
          role
          employeeId
          enterpriseId
          storeId
          pin
          status
          locationId
          employee {
            id
            role
            lastName
            firstName
            name
            nickname
            phone
            email
            employeeStoreId
            employeeEnterpriseId
            organizations {
              items {
                id
                role
                employeeId
                enterpriseId
                storeId
                pin
                status
                locationId
                permissions
                updatedAt
                createdAt
              }
              nextToken
            }
            survey
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          permissions
          updatedAt
          createdAt
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        nextToken
      }
      survey
      updatedAt
      createdAt
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onUpdateEmployee = /* GraphQL */ `
  subscription OnUpdateEmployee {
    onUpdateEmployee {
      id
      role
      lastName
      firstName
      name
      nickname
      phone
      email
      employeeStoreId
      employeeEnterpriseId
      organizations {
        items {
          id
          role
          employeeId
          enterpriseId
          storeId
          pin
          status
          locationId
          employee {
            id
            role
            lastName
            firstName
            name
            nickname
            phone
            email
            employeeStoreId
            employeeEnterpriseId
            organizations {
              items {
                id
                role
                employeeId
                enterpriseId
                storeId
                pin
                status
                locationId
                permissions
                updatedAt
                createdAt
              }
              nextToken
            }
            survey
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          permissions
          updatedAt
          createdAt
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        nextToken
      }
      survey
      updatedAt
      createdAt
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onDeleteEmployee = /* GraphQL */ `
  subscription OnDeleteEmployee {
    onDeleteEmployee {
      id
      role
      lastName
      firstName
      name
      nickname
      phone
      email
      employeeStoreId
      employeeEnterpriseId
      organizations {
        items {
          id
          role
          employeeId
          enterpriseId
          storeId
          pin
          status
          locationId
          employee {
            id
            role
            lastName
            firstName
            name
            nickname
            phone
            email
            employeeStoreId
            employeeEnterpriseId
            organizations {
              items {
                id
                role
                employeeId
                enterpriseId
                storeId
                pin
                status
                locationId
                permissions
                updatedAt
                createdAt
              }
              nextToken
            }
            survey
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          permissions
          updatedAt
          createdAt
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        nextToken
      }
      survey
      updatedAt
      createdAt
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onCreateOrganization = /* GraphQL */ `
  subscription OnCreateOrganization {
    onCreateOrganization {
      id
      role
      employeeId
      enterpriseId
      storeId
      pin
      status
      locationId
      employee {
        id
        role
        lastName
        firstName
        name
        nickname
        phone
        email
        employeeStoreId
        employeeEnterpriseId
        organizations {
          items {
            id
            role
            employeeId
            enterpriseId
            storeId
            pin
            status
            locationId
            employee {
              id
              role
              lastName
              firstName
              name
              nickname
              phone
              email
              employeeStoreId
              employeeEnterpriseId
              organizations {
                nextToken
              }
              survey
              updatedAt
              createdAt
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
            }
            permissions
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          nextToken
        }
        survey
        updatedAt
        createdAt
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      permissions
      updatedAt
      createdAt
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onUpdateOrganization = /* GraphQL */ `
  subscription OnUpdateOrganization {
    onUpdateOrganization {
      id
      role
      employeeId
      enterpriseId
      storeId
      pin
      status
      locationId
      employee {
        id
        role
        lastName
        firstName
        name
        nickname
        phone
        email
        employeeStoreId
        employeeEnterpriseId
        organizations {
          items {
            id
            role
            employeeId
            enterpriseId
            storeId
            pin
            status
            locationId
            employee {
              id
              role
              lastName
              firstName
              name
              nickname
              phone
              email
              employeeStoreId
              employeeEnterpriseId
              organizations {
                nextToken
              }
              survey
              updatedAt
              createdAt
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
            }
            permissions
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          nextToken
        }
        survey
        updatedAt
        createdAt
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      permissions
      updatedAt
      createdAt
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onDeleteOrganization = /* GraphQL */ `
  subscription OnDeleteOrganization {
    onDeleteOrganization {
      id
      role
      employeeId
      enterpriseId
      storeId
      pin
      status
      locationId
      employee {
        id
        role
        lastName
        firstName
        name
        nickname
        phone
        email
        employeeStoreId
        employeeEnterpriseId
        organizations {
          items {
            id
            role
            employeeId
            enterpriseId
            storeId
            pin
            status
            locationId
            employee {
              id
              role
              lastName
              firstName
              name
              nickname
              phone
              email
              employeeStoreId
              employeeEnterpriseId
              organizations {
                nextToken
              }
              survey
              updatedAt
              createdAt
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
            }
            permissions
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          nextToken
        }
        survey
        updatedAt
        createdAt
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      permissions
      updatedAt
      createdAt
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onCreateRentalContract = /* GraphQL */ `
  subscription OnCreateRentalContract {
    onCreateRentalContract {
      id
      type
      storeId
      locationId
      businessOperatorId
      months
      quantity
      amount
      startDate
      endDate
      extraFees {
        name
        amount
        billedAt
        createdAt
      }
      updatedAt
      createdAt
      businessOperator {
        id
        businessNumber
        name
        createdAt
        updatedAt
      }
    }
  }
`;
export const onUpdateRentalContract = /* GraphQL */ `
  subscription OnUpdateRentalContract {
    onUpdateRentalContract {
      id
      type
      storeId
      locationId
      businessOperatorId
      months
      quantity
      amount
      startDate
      endDate
      extraFees {
        name
        amount
        billedAt
        createdAt
      }
      updatedAt
      createdAt
      businessOperator {
        id
        businessNumber
        name
        createdAt
        updatedAt
      }
    }
  }
`;
export const onDeleteRentalContract = /* GraphQL */ `
  subscription OnDeleteRentalContract {
    onDeleteRentalContract {
      id
      type
      storeId
      locationId
      businessOperatorId
      months
      quantity
      amount
      startDate
      endDate
      extraFees {
        name
        amount
        billedAt
        createdAt
      }
      updatedAt
      createdAt
      businessOperator {
        id
        businessNumber
        name
        createdAt
        updatedAt
      }
    }
  }
`;
export const onCreatePointTransaction = /* GraphQL */ `
  subscription OnCreatePointTransaction {
    onCreatePointTransaction {
      id
      locationId
      storeId
      type
      name
      method
      amount
      origin
      provider
      providerCustomerId
      providerShopNo
      providerSyncedAt
      currency
      point
      extraPoint
      extraExpire
      items {
        type
        itemId
        name
        parentId
        point
        amount
        quantity
      }
      quantity
      note
      orderId
      referId
      orderNumberPrefix
      orderNumber
      customerId
      pointTransactionCustomerId
      expiredAt
      salesDate
      eventId
      updatedAt
      createdAt
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
    }
  }
`;
export const onUpdatePointTransaction = /* GraphQL */ `
  subscription OnUpdatePointTransaction {
    onUpdatePointTransaction {
      id
      locationId
      storeId
      type
      name
      method
      amount
      origin
      provider
      providerCustomerId
      providerShopNo
      providerSyncedAt
      currency
      point
      extraPoint
      extraExpire
      items {
        type
        itemId
        name
        parentId
        point
        amount
        quantity
      }
      quantity
      note
      orderId
      referId
      orderNumberPrefix
      orderNumber
      customerId
      pointTransactionCustomerId
      expiredAt
      salesDate
      eventId
      updatedAt
      createdAt
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
    }
  }
`;
export const onDeletePointTransaction = /* GraphQL */ `
  subscription OnDeletePointTransaction {
    onDeletePointTransaction {
      id
      locationId
      storeId
      type
      name
      method
      amount
      origin
      provider
      providerCustomerId
      providerShopNo
      providerSyncedAt
      currency
      point
      extraPoint
      extraExpire
      items {
        type
        itemId
        name
        parentId
        point
        amount
        quantity
      }
      quantity
      note
      orderId
      referId
      orderNumberPrefix
      orderNumber
      customerId
      pointTransactionCustomerId
      expiredAt
      salesDate
      eventId
      updatedAt
      createdAt
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
    }
  }
`;
export const onCreateCustomerHistory = /* GraphQL */ `
  subscription OnCreateCustomerHistory {
    onCreateCustomerHistory {
      storeId
      createdAt
      locationId
      name
      phone
      birth
      gender
      status
      customerId
      storeCustomerId
      updatedAt
    }
  }
`;
export const onUpdateCustomerHistory = /* GraphQL */ `
  subscription OnUpdateCustomerHistory {
    onUpdateCustomerHistory {
      storeId
      createdAt
      locationId
      name
      phone
      birth
      gender
      status
      customerId
      storeCustomerId
      updatedAt
    }
  }
`;
export const onDeleteCustomerHistory = /* GraphQL */ `
  subscription OnDeleteCustomerHistory {
    onDeleteCustomerHistory {
      storeId
      createdAt
      locationId
      name
      phone
      birth
      gender
      status
      customerId
      storeCustomerId
      updatedAt
    }
  }
`;
export const onCreateCreditTransaction = /* GraphQL */ `
  subscription OnCreateCreditTransaction {
    onCreateCreditTransaction {
      id
      locationId
      storeId
      name
      type
      amount
      origin
      note
      currency
      parentId
      orderId
      orderNumberPrefix
      orderNumber
      customerId
      creditTransactionCustomerId
      description
      salesDate
      createdAt
      updatedAt
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
    }
  }
`;
export const onUpdateCreditTransaction = /* GraphQL */ `
  subscription OnUpdateCreditTransaction {
    onUpdateCreditTransaction {
      id
      locationId
      storeId
      name
      type
      amount
      origin
      note
      currency
      parentId
      orderId
      orderNumberPrefix
      orderNumber
      customerId
      creditTransactionCustomerId
      description
      salesDate
      createdAt
      updatedAt
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
    }
  }
`;
export const onDeleteCreditTransaction = /* GraphQL */ `
  subscription OnDeleteCreditTransaction {
    onDeleteCreditTransaction {
      id
      locationId
      storeId
      name
      type
      amount
      origin
      note
      currency
      parentId
      orderId
      orderNumberPrefix
      orderNumber
      customerId
      creditTransactionCustomerId
      description
      salesDate
      createdAt
      updatedAt
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
    }
  }
`;
export const onCreateSalesServiceHistory = /* GraphQL */ `
  subscription OnCreateSalesServiceHistory {
    onCreateSalesServiceHistory {
      storeId
      type
      status
      locationId
      quantity
      referId
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateSalesServiceHistory = /* GraphQL */ `
  subscription OnUpdateSalesServiceHistory {
    onUpdateSalesServiceHistory {
      storeId
      type
      status
      locationId
      quantity
      referId
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteSalesServiceHistory = /* GraphQL */ `
  subscription OnDeleteSalesServiceHistory {
    onDeleteSalesServiceHistory {
      storeId
      type
      status
      locationId
      quantity
      referId
      updatedAt
      createdAt
    }
  }
`;
export const onCreateLoyaltyHistory = /* GraphQL */ `
  subscription OnCreateLoyaltyHistory {
    onCreateLoyaltyHistory {
      storeId
      status
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateLoyaltyHistory = /* GraphQL */ `
  subscription OnUpdateLoyaltyHistory {
    onUpdateLoyaltyHistory {
      storeId
      status
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteLoyaltyHistory = /* GraphQL */ `
  subscription OnDeleteLoyaltyHistory {
    onDeleteLoyaltyHistory {
      storeId
      status
      createdAt
      updatedAt
    }
  }
`;
export const onCreateConfirmation = /* GraphQL */ `
  subscription OnCreateConfirmation {
    onCreateConfirmation {
      phone
      code
      expiredAt
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateConfirmation = /* GraphQL */ `
  subscription OnUpdateConfirmation {
    onUpdateConfirmation {
      phone
      code
      expiredAt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteConfirmation = /* GraphQL */ `
  subscription OnDeleteConfirmation {
    onDeleteConfirmation {
      phone
      code
      expiredAt
      createdAt
      updatedAt
    }
  }
`;
export const onCreateArticle = /* GraphQL */ `
  subscription OnCreateArticle {
    onCreateArticle {
      id
      category
      createdAt
      parentId
      url
      title
      description
      updatedAt
    }
  }
`;
export const onUpdateArticle = /* GraphQL */ `
  subscription OnUpdateArticle {
    onUpdateArticle {
      id
      category
      createdAt
      parentId
      url
      title
      description
      updatedAt
    }
  }
`;
export const onDeleteArticle = /* GraphQL */ `
  subscription OnDeleteArticle {
    onDeleteArticle {
      id
      category
      createdAt
      parentId
      url
      title
      description
      updatedAt
    }
  }
`;
export const onCreateNotice = /* GraphQL */ `
  subscription OnCreateNotice {
    onCreateNotice {
      id
      enterpriseId
      storeId
      employeeId
      status
      type
      visibility
      title
      description
      attachment {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      parentId
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateNotice = /* GraphQL */ `
  subscription OnUpdateNotice {
    onUpdateNotice {
      id
      enterpriseId
      storeId
      employeeId
      status
      type
      visibility
      title
      description
      attachment {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      parentId
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteNotice = /* GraphQL */ `
  subscription OnDeleteNotice {
    onDeleteNotice {
      id
      enterpriseId
      storeId
      employeeId
      status
      type
      visibility
      title
      description
      attachment {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      parentId
      updatedAt
      createdAt
    }
  }
`;
export const onCreateNoticeCampaignResult = /* GraphQL */ `
  subscription OnCreateNoticeCampaignResult {
    onCreateNoticeCampaignResult {
      id
      recipientStoreId
      recipientLocationId
      campaignId
      noticeId
      notice {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      read
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateNoticeCampaignResult = /* GraphQL */ `
  subscription OnUpdateNoticeCampaignResult {
    onUpdateNoticeCampaignResult {
      id
      recipientStoreId
      recipientLocationId
      campaignId
      noticeId
      notice {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      read
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteNoticeCampaignResult = /* GraphQL */ `
  subscription OnDeleteNoticeCampaignResult {
    onDeleteNoticeCampaignResult {
      id
      recipientStoreId
      recipientLocationId
      campaignId
      noticeId
      notice {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      read
      updatedAt
      createdAt
    }
  }
`;
export const onCreateNoticeCampaign = /* GraphQL */ `
  subscription OnCreateNoticeCampaign {
    onCreateNoticeCampaign {
      id
      enterpriseId
      storeId
      status
      title
      reserveDate
      sendNow
      noticeId
      notice {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateNoticeCampaign = /* GraphQL */ `
  subscription OnUpdateNoticeCampaign {
    onUpdateNoticeCampaign {
      id
      enterpriseId
      storeId
      status
      title
      reserveDate
      sendNow
      noticeId
      notice {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteNoticeCampaign = /* GraphQL */ `
  subscription OnDeleteNoticeCampaign {
    onDeleteNoticeCampaign {
      id
      enterpriseId
      storeId
      status
      title
      reserveDate
      sendNow
      noticeId
      notice {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onCreateOnoffConfig = /* GraphQL */ `
  subscription OnCreateOnoffConfig {
    onCreateOnoffConfig {
      storeId
      stage
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      tierBenefits {
        id
        description
      }
      theme {
        primaryColor
        secondaryColor
        templateCode
      }
      item {
        stockInfo
      }
      banners {
        position
        url
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      mallUrl
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateOnoffConfig = /* GraphQL */ `
  subscription OnUpdateOnoffConfig {
    onUpdateOnoffConfig {
      storeId
      stage
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      tierBenefits {
        id
        description
      }
      theme {
        primaryColor
        secondaryColor
        templateCode
      }
      item {
        stockInfo
      }
      banners {
        position
        url
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      mallUrl
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteOnoffConfig = /* GraphQL */ `
  subscription OnDeleteOnoffConfig {
    onDeleteOnoffConfig {
      storeId
      stage
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      tierBenefits {
        id
        description
      }
      theme {
        primaryColor
        secondaryColor
        templateCode
      }
      item {
        stockInfo
      }
      banners {
        position
        url
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      mallUrl
      updatedAt
      createdAt
    }
  }
`;
export const onCreateCustomerEvent = /* GraphQL */ `
  subscription OnCreateCustomerEvent {
    onCreateCustomerEvent {
      id
      status
      type
      storeId
      employeeId
      name
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      condition {
        memberOnly
        joinUrl
        amount
        productIds
        entryLimit
        tierIds
        newOnly
      }
      mainTitle
      mainTitleMl {
        en
        zh
        ja
      }
      subTitle
      subTitleMl {
        en
        zh
        ja
      }
      design {
        backgroundColor
        pointColor
        textColor
        buttonRadius
        buttonTextColor
        rouletteType
        roulettePointColor
        rouletteTextColor
      }
      startDate
      endDate
      description
      descriptionMl {
        en
        zh
        ja
      }
      links {
        name
        url
      }
      notice
      noticeMl {
        en
        zh
        ja
      }
      missions {
        key
        action
        instagram
        instagramId
        kakao
        cafe24
        imweb
      }
      rewards {
        type
        name
        couponId
        providerCouponId
        point
        rate
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateCustomerEvent = /* GraphQL */ `
  subscription OnUpdateCustomerEvent {
    onUpdateCustomerEvent {
      id
      status
      type
      storeId
      employeeId
      name
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      condition {
        memberOnly
        joinUrl
        amount
        productIds
        entryLimit
        tierIds
        newOnly
      }
      mainTitle
      mainTitleMl {
        en
        zh
        ja
      }
      subTitle
      subTitleMl {
        en
        zh
        ja
      }
      design {
        backgroundColor
        pointColor
        textColor
        buttonRadius
        buttonTextColor
        rouletteType
        roulettePointColor
        rouletteTextColor
      }
      startDate
      endDate
      description
      descriptionMl {
        en
        zh
        ja
      }
      links {
        name
        url
      }
      notice
      noticeMl {
        en
        zh
        ja
      }
      missions {
        key
        action
        instagram
        instagramId
        kakao
        cafe24
        imweb
      }
      rewards {
        type
        name
        couponId
        providerCouponId
        point
        rate
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteCustomerEvent = /* GraphQL */ `
  subscription OnDeleteCustomerEvent {
    onDeleteCustomerEvent {
      id
      status
      type
      storeId
      employeeId
      name
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      condition {
        memberOnly
        joinUrl
        amount
        productIds
        entryLimit
        tierIds
        newOnly
      }
      mainTitle
      mainTitleMl {
        en
        zh
        ja
      }
      subTitle
      subTitleMl {
        en
        zh
        ja
      }
      design {
        backgroundColor
        pointColor
        textColor
        buttonRadius
        buttonTextColor
        rouletteType
        roulettePointColor
        rouletteTextColor
      }
      startDate
      endDate
      description
      descriptionMl {
        en
        zh
        ja
      }
      links {
        name
        url
      }
      notice
      noticeMl {
        en
        zh
        ja
      }
      missions {
        key
        action
        instagram
        instagramId
        kakao
        cafe24
        imweb
      }
      rewards {
        type
        name
        couponId
        providerCouponId
        point
        rate
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreatePaymentTerminal = /* GraphQL */ `
  subscription OnCreatePaymentTerminal {
    onCreatePaymentTerminal {
      id
      businessNumber
      businessOperatorId
      storeId
      locationId
      serial
      model
      brand
      updatedAt
      createdAt
    }
  }
`;
export const onUpdatePaymentTerminal = /* GraphQL */ `
  subscription OnUpdatePaymentTerminal {
    onUpdatePaymentTerminal {
      id
      businessNumber
      businessOperatorId
      storeId
      locationId
      serial
      model
      brand
      updatedAt
      createdAt
    }
  }
`;
export const onDeletePaymentTerminal = /* GraphQL */ `
  subscription OnDeletePaymentTerminal {
    onDeletePaymentTerminal {
      id
      businessNumber
      businessOperatorId
      storeId
      locationId
      serial
      model
      brand
      updatedAt
      createdAt
    }
  }
`;
export const onCreateEnvironment = /* GraphQL */ `
  subscription OnCreateEnvironment {
    onCreateEnvironment {
      id
      appVersion
      pcVersion
      webVersion
      inventoryDeployedAt
      credits {
        quantity
        amount
        discount
      }
      merchantPassword
      noticeDate
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateEnvironment = /* GraphQL */ `
  subscription OnUpdateEnvironment {
    onUpdateEnvironment {
      id
      appVersion
      pcVersion
      webVersion
      inventoryDeployedAt
      credits {
        quantity
        amount
        discount
      }
      merchantPassword
      noticeDate
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteEnvironment = /* GraphQL */ `
  subscription OnDeleteEnvironment {
    onDeleteEnvironment {
      id
      appVersion
      pcVersion
      webVersion
      inventoryDeployedAt
      credits {
        quantity
        amount
        discount
      }
      merchantPassword
      noticeDate
      updatedAt
      createdAt
    }
  }
`;
export const onCreateOrder = /* GraphQL */ `
  subscription OnCreateOrder {
    onCreateOrder {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      giftReceiverKey
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      note
      request
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      orderCustomer {
        id
        enterpriseId
        storeId
        locationId
        customerId
        provider
        providerCustomerId
        shopNo
        tier
        tierId
        customerCreatedAt
        ident
        identType
        type
        name
        nameKeyword
        payments {
          id
          method
          pg
          number
          name
          expMonth
          expYear
          billingKey
          updatedAt
          createdAt
        }
        attributes {
          name
          type
          value
        }
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        tags {
          tagId
          createdLocationId
        }
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        salesDate
        campaignBlockedAt
        blacklistedAt
        isFavorite
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
    }
  }
`;
export const onUpdateOrder = /* GraphQL */ `
  subscription OnUpdateOrder {
    onUpdateOrder {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      giftReceiverKey
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      note
      request
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      orderCustomer {
        id
        enterpriseId
        storeId
        locationId
        customerId
        provider
        providerCustomerId
        shopNo
        tier
        tierId
        customerCreatedAt
        ident
        identType
        type
        name
        nameKeyword
        payments {
          id
          method
          pg
          number
          name
          expMonth
          expYear
          billingKey
          updatedAt
          createdAt
        }
        attributes {
          name
          type
          value
        }
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        tags {
          tagId
          createdLocationId
        }
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        salesDate
        campaignBlockedAt
        blacklistedAt
        isFavorite
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
    }
  }
`;
export const onDeleteOrder = /* GraphQL */ `
  subscription OnDeleteOrder {
    onDeleteOrder {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      giftReceiverKey
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      note
      request
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            giftReceiverKey
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
            app {
              locationId
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      orderCustomer {
        id
        enterpriseId
        storeId
        locationId
        customerId
        provider
        providerCustomerId
        shopNo
        tier
        tierId
        customerCreatedAt
        ident
        identType
        type
        name
        nameKeyword
        payments {
          id
          method
          pg
          number
          name
          expMonth
          expYear
          billingKey
          updatedAt
          createdAt
        }
        attributes {
          name
          type
          value
        }
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        tags {
          tagId
          createdLocationId
        }
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        salesDate
        campaignBlockedAt
        blacklistedAt
        isFavorite
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
    }
  }
`;
export const onCreateOrderDelta = /* GraphQL */ `
  subscription OnCreateOrderDelta {
    onCreateOrderDelta {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      giftReceiverKey
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      request
      note
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdateOrderDelta = /* GraphQL */ `
  subscription OnUpdateOrderDelta {
    onUpdateOrderDelta {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      giftReceiverKey
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      request
      note
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      timestamp
      expdate
    }
  }
`;
export const onDeleteOrderDelta = /* GraphQL */ `
  subscription OnDeleteOrderDelta {
    onDeleteOrderDelta {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      giftReceiverKey
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      request
      note
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      timestamp
      expdate
    }
  }
`;
export const onCreateOrderTicketDelta = /* GraphQL */ `
  subscription OnCreateOrderTicketDelta {
    onCreateOrderTicketDelta {
      id
      storeId
      locationId
      orderId
      items {
        id
        diningState
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      order {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        giftReceiverKey
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
    }
  }
`;
export const onUpdateOrderTicketDelta = /* GraphQL */ `
  subscription OnUpdateOrderTicketDelta {
    onUpdateOrderTicketDelta {
      id
      storeId
      locationId
      orderId
      items {
        id
        diningState
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      order {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        giftReceiverKey
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
    }
  }
`;
export const onDeleteOrderTicketDelta = /* GraphQL */ `
  subscription OnDeleteOrderTicketDelta {
    onDeleteOrderTicketDelta {
      id
      storeId
      locationId
      orderId
      items {
        id
        diningState
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      order {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        giftReceiverKey
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
    }
  }
`;
export const onCreateCustomerTag = /* GraphQL */ `
  subscription OnCreateCustomerTag {
    onCreateCustomerTag {
      id
      label
      description
      color
      customerIds
      storeId
      locationId
      type
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateCustomerTag = /* GraphQL */ `
  subscription OnUpdateCustomerTag {
    onUpdateCustomerTag {
      id
      label
      description
      color
      customerIds
      storeId
      locationId
      type
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteCustomerTag = /* GraphQL */ `
  subscription OnDeleteCustomerTag {
    onDeleteCustomerTag {
      id
      label
      description
      color
      customerIds
      storeId
      locationId
      type
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateCustomerTagDelta = /* GraphQL */ `
  subscription OnCreateCustomerTagDelta {
    onCreateCustomerTagDelta {
      id
      type
      label
      description
      color
      storeId
      locationId
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdateCustomerTagDelta = /* GraphQL */ `
  subscription OnUpdateCustomerTagDelta {
    onUpdateCustomerTagDelta {
      id
      type
      label
      description
      color
      storeId
      locationId
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onDeleteCustomerTagDelta = /* GraphQL */ `
  subscription OnDeleteCustomerTagDelta {
    onDeleteCustomerTagDelta {
      id
      type
      label
      description
      color
      storeId
      locationId
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onCreateCouponTransaction = /* GraphQL */ `
  subscription OnCreateCouponTransaction {
    onCreateCouponTransaction {
      id
      usedAt
      state
      amount
      quantity
      refundedAt
      orderId
      customerId
      couponTransactionCustomerId
      updatedAt
      createdAt
      expiredDate
      barcode
      generateLocationId
      generatedAt
      couponTransactionsId
      enterpriseId
      storeId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      provider
      providerCouponId
      providerTransactionId
      providerCustomerId
      providerShopNo
      name
      code
      type
      method
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      campaignId
      eventId
      startedAt
      endedAt
    }
  }
`;
export const onUpdateCouponTransaction = /* GraphQL */ `
  subscription OnUpdateCouponTransaction {
    onUpdateCouponTransaction {
      id
      usedAt
      state
      amount
      quantity
      refundedAt
      orderId
      customerId
      couponTransactionCustomerId
      updatedAt
      createdAt
      expiredDate
      barcode
      generateLocationId
      generatedAt
      couponTransactionsId
      enterpriseId
      storeId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      provider
      providerCouponId
      providerTransactionId
      providerCustomerId
      providerShopNo
      name
      code
      type
      method
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      campaignId
      eventId
      startedAt
      endedAt
    }
  }
`;
export const onDeleteCouponTransaction = /* GraphQL */ `
  subscription OnDeleteCouponTransaction {
    onDeleteCouponTransaction {
      id
      usedAt
      state
      amount
      quantity
      refundedAt
      orderId
      customerId
      couponTransactionCustomerId
      updatedAt
      createdAt
      expiredDate
      barcode
      generateLocationId
      generatedAt
      couponTransactionsId
      enterpriseId
      storeId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      provider
      providerCouponId
      providerTransactionId
      providerCustomerId
      providerShopNo
      name
      code
      type
      method
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      campaignId
      eventId
      startedAt
      endedAt
    }
  }
`;
export const onCreateCoupon = /* GraphQL */ `
  subscription OnCreateCoupon {
    onCreateCoupon {
      id
      storeId
      enterpriseId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      provider
      providerCouponId
      name
      description
      availableOrigins
      code
      type
      method
      tranCount
      generateCount
      publishCount
      limitPublishCount
      duplicatePublish
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionItemsOperator
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      referId
      validDateType
      validValue
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      notice
      pointSavable
      startedAt
      endedAt
      updatedAt
      createdAt
      transactions {
        items {
          id
          usedAt
          state
          amount
          quantity
          refundedAt
          orderId
          customerId
          couponTransactionCustomerId
          updatedAt
          createdAt
          expiredDate
          barcode
          generateLocationId
          generatedAt
          couponTransactionsId
          enterpriseId
          storeId
          locationId
          activeLocationIds
          inactiveLocationIds
          publishableLocationIds
          provider
          providerCouponId
          providerTransactionId
          providerCustomerId
          providerShopNo
          name
          code
          type
          method
          conditionType
          conditionQuantity
          conditionAmount
          conditionItems
          conditionTimes {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          conditionTier
          conditionMinAmount
          conditionMaxAmount
          discountMethod
          discountValue
          applyScope
          applyItemId
          applyCandidateItemIds
          applyCandidateItemModels
          applyExcludeItemModels
          campaignId
          eventId
          startedAt
          endedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateCoupon = /* GraphQL */ `
  subscription OnUpdateCoupon {
    onUpdateCoupon {
      id
      storeId
      enterpriseId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      provider
      providerCouponId
      name
      description
      availableOrigins
      code
      type
      method
      tranCount
      generateCount
      publishCount
      limitPublishCount
      duplicatePublish
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionItemsOperator
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      referId
      validDateType
      validValue
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      notice
      pointSavable
      startedAt
      endedAt
      updatedAt
      createdAt
      transactions {
        items {
          id
          usedAt
          state
          amount
          quantity
          refundedAt
          orderId
          customerId
          couponTransactionCustomerId
          updatedAt
          createdAt
          expiredDate
          barcode
          generateLocationId
          generatedAt
          couponTransactionsId
          enterpriseId
          storeId
          locationId
          activeLocationIds
          inactiveLocationIds
          publishableLocationIds
          provider
          providerCouponId
          providerTransactionId
          providerCustomerId
          providerShopNo
          name
          code
          type
          method
          conditionType
          conditionQuantity
          conditionAmount
          conditionItems
          conditionTimes {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          conditionTier
          conditionMinAmount
          conditionMaxAmount
          discountMethod
          discountValue
          applyScope
          applyItemId
          applyCandidateItemIds
          applyCandidateItemModels
          applyExcludeItemModels
          campaignId
          eventId
          startedAt
          endedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteCoupon = /* GraphQL */ `
  subscription OnDeleteCoupon {
    onDeleteCoupon {
      id
      storeId
      enterpriseId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      provider
      providerCouponId
      name
      description
      availableOrigins
      code
      type
      method
      tranCount
      generateCount
      publishCount
      limitPublishCount
      duplicatePublish
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionItemsOperator
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      conditionMaxAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      referId
      validDateType
      validValue
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      notice
      pointSavable
      startedAt
      endedAt
      updatedAt
      createdAt
      transactions {
        items {
          id
          usedAt
          state
          amount
          quantity
          refundedAt
          orderId
          customerId
          couponTransactionCustomerId
          updatedAt
          createdAt
          expiredDate
          barcode
          generateLocationId
          generatedAt
          couponTransactionsId
          enterpriseId
          storeId
          locationId
          activeLocationIds
          inactiveLocationIds
          publishableLocationIds
          provider
          providerCouponId
          providerTransactionId
          providerCustomerId
          providerShopNo
          name
          code
          type
          method
          conditionType
          conditionQuantity
          conditionAmount
          conditionItems
          conditionTimes {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          conditionTier
          conditionMinAmount
          conditionMaxAmount
          discountMethod
          discountValue
          applyScope
          applyItemId
          applyCandidateItemIds
          applyCandidateItemModels
          applyExcludeItemModels
          campaignId
          eventId
          startedAt
          endedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateReviewCampaignResult = /* GraphQL */ `
  subscription OnCreateReviewCampaignResult {
    onCreateReviewCampaignResult {
      id
      campaignId
      enterpriseId
      storeId
      locationId
      orderId
      orderNumberPrefix
      orderNumber
      customerId
      storeCustomerId
      reserveDate
      sentAt
      submittedAt
      rate
      comment
      answers
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateReviewCampaignResult = /* GraphQL */ `
  subscription OnUpdateReviewCampaignResult {
    onUpdateReviewCampaignResult {
      id
      campaignId
      enterpriseId
      storeId
      locationId
      orderId
      orderNumberPrefix
      orderNumber
      customerId
      storeCustomerId
      reserveDate
      sentAt
      submittedAt
      rate
      comment
      answers
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteReviewCampaignResult = /* GraphQL */ `
  subscription OnDeleteReviewCampaignResult {
    onDeleteReviewCampaignResult {
      id
      campaignId
      enterpriseId
      storeId
      locationId
      orderId
      orderNumberPrefix
      orderNumber
      customerId
      storeCustomerId
      reserveDate
      sentAt
      submittedAt
      rate
      comment
      answers
      updatedAt
      createdAt
    }
  }
`;
export const onCreateReviewCampaign = /* GraphQL */ `
  subscription OnCreateReviewCampaign {
    onCreateReviewCampaign {
      id
      status
      enterpriseId
      storeId
      locationId
      name
      delay
      trial
      limit
      basic
      rewardPoint
      templateId
      templateName
      questions
      stats
      startedAt
      endedAt
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateReviewCampaign = /* GraphQL */ `
  subscription OnUpdateReviewCampaign {
    onUpdateReviewCampaign {
      id
      status
      enterpriseId
      storeId
      locationId
      name
      delay
      trial
      limit
      basic
      rewardPoint
      templateId
      templateName
      questions
      stats
      startedAt
      endedAt
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteReviewCampaign = /* GraphQL */ `
  subscription OnDeleteReviewCampaign {
    onDeleteReviewCampaign {
      id
      status
      enterpriseId
      storeId
      locationId
      name
      delay
      trial
      limit
      basic
      rewardPoint
      templateId
      templateName
      questions
      stats
      startedAt
      endedAt
      updatedAt
      createdAt
    }
  }
`;
export const onCreatePurchaseOrder = /* GraphQL */ `
  subscription OnCreatePurchaseOrder {
    onCreatePurchaseOrder {
      id
      number
      supplierId
      supplyingLocationId
      status
      supplierOrigin
      inventories {
        id
        inventoryId
        productId
        skuId
        quantity
        receivedQuantity
        waitingQuantity
        cancelledQuantity
        cost
        note
      }
      storeId
      locationId
      createdByEmployeeId
      createdLocationId
      note
      extraFees {
        id
        type
        value
        name
      }
      excludeVat
      expectDate
      confirmedAt
      receivedAt
      updatedAt
      createdAt
    }
  }
`;
export const onUpdatePurchaseOrder = /* GraphQL */ `
  subscription OnUpdatePurchaseOrder {
    onUpdatePurchaseOrder {
      id
      number
      supplierId
      supplyingLocationId
      status
      supplierOrigin
      inventories {
        id
        inventoryId
        productId
        skuId
        quantity
        receivedQuantity
        waitingQuantity
        cancelledQuantity
        cost
        note
      }
      storeId
      locationId
      createdByEmployeeId
      createdLocationId
      note
      extraFees {
        id
        type
        value
        name
      }
      excludeVat
      expectDate
      confirmedAt
      receivedAt
      updatedAt
      createdAt
    }
  }
`;
export const onDeletePurchaseOrder = /* GraphQL */ `
  subscription OnDeletePurchaseOrder {
    onDeletePurchaseOrder {
      id
      number
      supplierId
      supplyingLocationId
      status
      supplierOrigin
      inventories {
        id
        inventoryId
        productId
        skuId
        quantity
        receivedQuantity
        waitingQuantity
        cancelledQuantity
        cost
        note
      }
      storeId
      locationId
      createdByEmployeeId
      createdLocationId
      note
      extraFees {
        id
        type
        value
        name
      }
      excludeVat
      expectDate
      confirmedAt
      receivedAt
      updatedAt
      createdAt
    }
  }
`;
export const onCreateStoreSupplier = /* GraphQL */ `
  subscription OnCreateStoreSupplier {
    onCreateStoreSupplier {
      id
      storeId
      name
      phone
      fax
      email
      note
      address
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateStoreSupplier = /* GraphQL */ `
  subscription OnUpdateStoreSupplier {
    onUpdateStoreSupplier {
      id
      storeId
      name
      phone
      fax
      email
      note
      address
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteStoreSupplier = /* GraphQL */ `
  subscription OnDeleteStoreSupplier {
    onDeleteStoreSupplier {
      id
      storeId
      name
      phone
      fax
      email
      note
      address
      updatedAt
      createdAt
    }
  }
`;
export const onCreateItems = /* GraphQL */ `
  subscription OnCreateItems {
    onCreateItems {
      id
      products {
        type
        id
        itemId
        name
        description
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        image
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        locationIds
      }
      productModifiers {
        productId
        modifierId
      }
      categoryProducts {
        categoryId
        productId
      }
      modifiers {
        type
        id
        itemId
        name
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        locationIds
      }
      categories {
        type
        id
        itemId
        name
        displayName
        locationIds
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateItems = /* GraphQL */ `
  subscription OnUpdateItems {
    onUpdateItems {
      id
      products {
        type
        id
        itemId
        name
        description
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        image
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        locationIds
      }
      productModifiers {
        productId
        modifierId
      }
      categoryProducts {
        categoryId
        productId
      }
      modifiers {
        type
        id
        itemId
        name
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        locationIds
      }
      categories {
        type
        id
        itemId
        name
        displayName
        locationIds
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteItems = /* GraphQL */ `
  subscription OnDeleteItems {
    onDeleteItems {
      id
      products {
        type
        id
        itemId
        name
        description
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        image
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        locationIds
      }
      productModifiers {
        productId
        modifierId
      }
      categoryProducts {
        categoryId
        productId
      }
      modifiers {
        type
        id
        itemId
        name
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        locationIds
      }
      categories {
        type
        id
        itemId
        name
        displayName
        locationIds
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateItemDelta = /* GraphQL */ `
  subscription OnCreateItemDelta {
    onCreateItemDelta {
      id
      itemId
      type
      code
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      attributes {
        name
        type
        value
      }
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      brandIds
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      active
      origin
      refer
      referId
      depth
      parentId
      parentCategoryId
      sortKey
      subCategoryProductDisplay
      description
      descriptionMl {
        en
        zh
        ja
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      variablePrice
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      ordering
      categoryIds
      classificationIds
      modifierIds
      productIds
      locationIds
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdateItemDelta = /* GraphQL */ `
  subscription OnUpdateItemDelta {
    onUpdateItemDelta {
      id
      itemId
      type
      code
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      attributes {
        name
        type
        value
      }
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      brandIds
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      active
      origin
      refer
      referId
      depth
      parentId
      parentCategoryId
      sortKey
      subCategoryProductDisplay
      description
      descriptionMl {
        en
        zh
        ja
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      variablePrice
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      ordering
      categoryIds
      classificationIds
      modifierIds
      productIds
      locationIds
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onDeleteItemDelta = /* GraphQL */ `
  subscription OnDeleteItemDelta {
    onDeleteItemDelta {
      id
      itemId
      type
      code
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      attributes {
        name
        type
        value
      }
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      brandIds
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      active
      origin
      refer
      referId
      depth
      parentId
      parentCategoryId
      sortKey
      subCategoryProductDisplay
      description
      descriptionMl {
        en
        zh
        ja
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      variablePrice
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      ordering
      categoryIds
      classificationIds
      modifierIds
      productIds
      locationIds
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onCreateLocationItemDelta = /* GraphQL */ `
  subscription OnCreateLocationItemDelta {
    onCreateLocationItemDelta {
      id
      scope
      seqKey
      storeId
      locationId
      streamType
      seq
      deltaType
      entityId
      payload
      expiresAt
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateLocationItemDelta = /* GraphQL */ `
  subscription OnUpdateLocationItemDelta {
    onUpdateLocationItemDelta {
      id
      scope
      seqKey
      storeId
      locationId
      streamType
      seq
      deltaType
      entityId
      payload
      expiresAt
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteLocationItemDelta = /* GraphQL */ `
  subscription OnDeleteLocationItemDelta {
    onDeleteLocationItemDelta {
      id
      scope
      seqKey
      storeId
      locationId
      streamType
      seq
      deltaType
      entityId
      payload
      expiresAt
      updatedAt
      createdAt
    }
  }
`;
export const onCreateLocationItemManifest = /* GraphQL */ `
  subscription OnCreateLocationItemManifest {
    onCreateLocationItemManifest {
      id
      storeId
      locationId
      lastSeq
      snapshot {
        version
        key
        etag
        size
        generatedAt
        seqAt
      }
      snapshotInProgress
      snapshotTargetSeq
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateLocationItemManifest = /* GraphQL */ `
  subscription OnUpdateLocationItemManifest {
    onUpdateLocationItemManifest {
      id
      storeId
      locationId
      lastSeq
      snapshot {
        version
        key
        etag
        size
        generatedAt
        seqAt
      }
      snapshotInProgress
      snapshotTargetSeq
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteLocationItemManifest = /* GraphQL */ `
  subscription OnDeleteLocationItemManifest {
    onDeleteLocationItemManifest {
      id
      storeId
      locationId
      lastSeq
      snapshot {
        version
        key
        etag
        size
        generatedAt
        seqAt
      }
      snapshotInProgress
      snapshotTargetSeq
      updatedAt
      createdAt
    }
  }
`;
export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct {
    onCreateProduct {
      id
      type
      enterpriseId
      storeId
      origin
      refer
      referId
      name
      nameMl {
        en
        zh
        ja
      }
      description
      descriptionMl {
        en
        zh
        ja
      }
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      variablePrice
      attributes {
        name
        type
        value
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      categories {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      classifications {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      modifiers {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct {
    onUpdateProduct {
      id
      type
      enterpriseId
      storeId
      origin
      refer
      referId
      name
      nameMl {
        en
        zh
        ja
      }
      description
      descriptionMl {
        en
        zh
        ja
      }
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      variablePrice
      attributes {
        name
        type
        value
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      categories {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      classifications {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      modifiers {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct {
    onDeleteProduct {
      id
      type
      enterpriseId
      storeId
      origin
      refer
      referId
      name
      nameMl {
        en
        zh
        ja
      }
      description
      descriptionMl {
        en
        zh
        ja
      }
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      variablePrice
      attributes {
        name
        type
        value
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      categories {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      classifications {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      modifiers {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const onCreateLocation = /* GraphQL */ `
  subscription OnCreateLocation {
    onCreateLocation {
      id
      name
      type
      code
      brand
      brandId
      provider
      address
      zip
      phone
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      representative
      businessNumber
      billing {
        key
        businessNumber
        name
        email
        phone
        contanctName
        contactName
        address
        zip
        card {
          pg
          number
          name
          expMonth
          expYear
          identify
          password
          billingKey
        }
      }
      credit {
        autoCharge
        autoChargeCredit
        autoChargeQuantity
        alertCredit
      }
      businessHours {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      storeId
      state
      menuPlanId
      payments {
        refund
        barcode
        barcodeVan
        barcodeTerminalId
      }
      policy {
        locationCost
        loyaltyCost
      }
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      kiosk {
        status
        callable
        payable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        exchangeTicket
        columnSize
        discounts {
          condition
          couponId
        }
        menuDescription
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        titles
        titlePosition
        updatedAt
        createdAt
      }
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      menuOrder {
        callOptions {
          index
          label
        }
        orderable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        columnSize
        fontSize
        notice
        resetTime
        enableCash
        boardType
      }
      kds {
        layout
        alerts {
          urgent
          warning
        }
        disabledProdIds
        orderNotify
      }
      mini {
        defaultItemName
      }
      orderPlanId
      menu {
        board {
          textSize
          columnSize
          pages {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          favorite {
            parentId
            badge
            type
            position
            activeOptions
          }
          enableFavorite
        }
        list {
          pages {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          favorite {
            parentId
            badge
            type
            position
            activeOptions
          }
          shortcuts {
            type
            title
            itemName
            itemPrice
            active
          }
        }
        navOrder
      }
      menus {
        parentId
        position
        page
        pageTitle
      }
      favMenus {
        parentId
        position
        page
        pageTitle
      }
      catMenus {
        title
        index
        ids
        parentId
      }
      market {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        paused
        takeoutDiscount
        creditDiscount
        takeout
        intro
        notice
        bookTable
        bookTableNote
        depositAmount
        delivery
        deliveryFee {
          start
          end
          fee
        }
        waitingTime
        itemIds
        updatedAt
        createdAt
      }
      waiting {
        status
        waitingOptions {
          id
          type
          name
          nameMl {
            en
            zh
            ja
          }
          items {
            id
            name
            nameMl {
              en
              zh
              ja
            }
            limitQuantity
          }
          required
          updatedAt
          createdAt
        }
        waitingMinutes
        waitingMinutesHide
        hasForeigner
        foreignerMethod
        notifications {
          created
          ready
          requested
          cancelled
        }
        notices {
          createdNotice
          createdNoticeMl {
            en
            zh
            ja
          }
          requestedNotice
          requestedNoticeMl {
            en
            zh
            ja
          }
        }
        settings {
          autoCancel
          autoCancelMinutes
        }
        updatedAt
        createdAt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      view {
        order {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
        itemReport {
          excludeColumns
        }
        summaryReport {
          excludeColumns
        }
        shippingOrder {
          excludeColumns
        }
        trsItemReport {
          excludeColumns
        }
        customReport {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
      }
      subscription {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        updatedAt
        createdAt
      }
      settings {
        mode
        table
        diningOption
        retailOption
        orderAlarm
        orderConfirm
        addressInput
        autoPay
        autoReturnItem
        autoSoldout
        menuGridSize
        menuMode
        tableMode
        orderNotify
        orderNotifySkippable
        disablePhonePrefix
        autoCloseScreen
        orderNumberPrefix {
          pos
          kiosk
          menuOrder
        }
        orderMgmt {
          kiosk
          menuorder
          delivery
          pos
        }
        reportBasis
        orderOrigins
        beeper {
          active
          coverage
          skippable
        }
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        customerOptions {
          countries
          ages
          gender
        }
      }
      devices {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      tables {
        id
        width
        height
        name
        axisX
        axisY
        screenHeight
        screenWidth
        initialX
        initialY
        shape
        layout {
          x
          y
          w
          h
        }
        color
        orderId
        disabled
      }
      boardTables {
        title
        index
        items {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
      }
      gridTables {
        id
        name
        orderId
        index
        page
      }
      modifierSoldoutIds
      delivery {
        baemin
        coupang
        yogiyo
        enableGenProd
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
      sales {
        startedAt
        endedAt
        reserves
        actualBalance
        currency
        note
        estimateBalance
        detail {
          totalSales
          totalRefund
          totalTax
          totalDiscount
          supplyAmount
          totalSalesCount
          cash {
            sales
            refund
          }
          card {
            sales
            refund
          }
          credit {
            sales
            refund
          }
          barcode {
            sales
            refund
          }
          extra {
            sales
            refund
          }
          refund {
            sales
            refund
          }
          products {
            id
            name
            quantity
            amount
          }
          origins {
            pos
            kiosk
            menuorder
            delivery
            market
          }
        }
        reservesHistories {
          type
          amount
          note
          createdEmployeeId
          createdAt
        }
      }
    }
  }
`;
export const onUpdateLocation = /* GraphQL */ `
  subscription OnUpdateLocation {
    onUpdateLocation {
      id
      name
      type
      code
      brand
      brandId
      provider
      address
      zip
      phone
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      representative
      businessNumber
      billing {
        key
        businessNumber
        name
        email
        phone
        contanctName
        contactName
        address
        zip
        card {
          pg
          number
          name
          expMonth
          expYear
          identify
          password
          billingKey
        }
      }
      credit {
        autoCharge
        autoChargeCredit
        autoChargeQuantity
        alertCredit
      }
      businessHours {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      storeId
      state
      menuPlanId
      payments {
        refund
        barcode
        barcodeVan
        barcodeTerminalId
      }
      policy {
        locationCost
        loyaltyCost
      }
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      kiosk {
        status
        callable
        payable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        exchangeTicket
        columnSize
        discounts {
          condition
          couponId
        }
        menuDescription
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        titles
        titlePosition
        updatedAt
        createdAt
      }
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      menuOrder {
        callOptions {
          index
          label
        }
        orderable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        columnSize
        fontSize
        notice
        resetTime
        enableCash
        boardType
      }
      kds {
        layout
        alerts {
          urgent
          warning
        }
        disabledProdIds
        orderNotify
      }
      mini {
        defaultItemName
      }
      orderPlanId
      menu {
        board {
          textSize
          columnSize
          pages {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          favorite {
            parentId
            badge
            type
            position
            activeOptions
          }
          enableFavorite
        }
        list {
          pages {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          favorite {
            parentId
            badge
            type
            position
            activeOptions
          }
          shortcuts {
            type
            title
            itemName
            itemPrice
            active
          }
        }
        navOrder
      }
      menus {
        parentId
        position
        page
        pageTitle
      }
      favMenus {
        parentId
        position
        page
        pageTitle
      }
      catMenus {
        title
        index
        ids
        parentId
      }
      market {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        paused
        takeoutDiscount
        creditDiscount
        takeout
        intro
        notice
        bookTable
        bookTableNote
        depositAmount
        delivery
        deliveryFee {
          start
          end
          fee
        }
        waitingTime
        itemIds
        updatedAt
        createdAt
      }
      waiting {
        status
        waitingOptions {
          id
          type
          name
          nameMl {
            en
            zh
            ja
          }
          items {
            id
            name
            nameMl {
              en
              zh
              ja
            }
            limitQuantity
          }
          required
          updatedAt
          createdAt
        }
        waitingMinutes
        waitingMinutesHide
        hasForeigner
        foreignerMethod
        notifications {
          created
          ready
          requested
          cancelled
        }
        notices {
          createdNotice
          createdNoticeMl {
            en
            zh
            ja
          }
          requestedNotice
          requestedNoticeMl {
            en
            zh
            ja
          }
        }
        settings {
          autoCancel
          autoCancelMinutes
        }
        updatedAt
        createdAt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      view {
        order {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
        itemReport {
          excludeColumns
        }
        summaryReport {
          excludeColumns
        }
        shippingOrder {
          excludeColumns
        }
        trsItemReport {
          excludeColumns
        }
        customReport {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
      }
      subscription {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        updatedAt
        createdAt
      }
      settings {
        mode
        table
        diningOption
        retailOption
        orderAlarm
        orderConfirm
        addressInput
        autoPay
        autoReturnItem
        autoSoldout
        menuGridSize
        menuMode
        tableMode
        orderNotify
        orderNotifySkippable
        disablePhonePrefix
        autoCloseScreen
        orderNumberPrefix {
          pos
          kiosk
          menuOrder
        }
        orderMgmt {
          kiosk
          menuorder
          delivery
          pos
        }
        reportBasis
        orderOrigins
        beeper {
          active
          coverage
          skippable
        }
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        customerOptions {
          countries
          ages
          gender
        }
      }
      devices {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      tables {
        id
        width
        height
        name
        axisX
        axisY
        screenHeight
        screenWidth
        initialX
        initialY
        shape
        layout {
          x
          y
          w
          h
        }
        color
        orderId
        disabled
      }
      boardTables {
        title
        index
        items {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
      }
      gridTables {
        id
        name
        orderId
        index
        page
      }
      modifierSoldoutIds
      delivery {
        baemin
        coupang
        yogiyo
        enableGenProd
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
      sales {
        startedAt
        endedAt
        reserves
        actualBalance
        currency
        note
        estimateBalance
        detail {
          totalSales
          totalRefund
          totalTax
          totalDiscount
          supplyAmount
          totalSalesCount
          cash {
            sales
            refund
          }
          card {
            sales
            refund
          }
          credit {
            sales
            refund
          }
          barcode {
            sales
            refund
          }
          extra {
            sales
            refund
          }
          refund {
            sales
            refund
          }
          products {
            id
            name
            quantity
            amount
          }
          origins {
            pos
            kiosk
            menuorder
            delivery
            market
          }
        }
        reservesHistories {
          type
          amount
          note
          createdEmployeeId
          createdAt
        }
      }
    }
  }
`;
export const onDeleteLocation = /* GraphQL */ `
  subscription OnDeleteLocation {
    onDeleteLocation {
      id
      name
      type
      code
      brand
      brandId
      provider
      address
      zip
      phone
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      representative
      businessNumber
      billing {
        key
        businessNumber
        name
        email
        phone
        contanctName
        contactName
        address
        zip
        card {
          pg
          number
          name
          expMonth
          expYear
          identify
          password
          billingKey
        }
      }
      credit {
        autoCharge
        autoChargeCredit
        autoChargeQuantity
        alertCredit
      }
      businessHours {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      storeId
      state
      menuPlanId
      payments {
        refund
        barcode
        barcodeVan
        barcodeTerminalId
      }
      policy {
        locationCost
        loyaltyCost
      }
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      kiosk {
        status
        callable
        payable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        exchangeTicket
        columnSize
        discounts {
          condition
          couponId
        }
        menuDescription
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        titles
        titlePosition
        updatedAt
        createdAt
      }
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      menuOrder {
        callOptions {
          index
          label
        }
        orderable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        columnSize
        fontSize
        notice
        resetTime
        enableCash
        boardType
      }
      kds {
        layout
        alerts {
          urgent
          warning
        }
        disabledProdIds
        orderNotify
      }
      mini {
        defaultItemName
      }
      orderPlanId
      menu {
        board {
          textSize
          columnSize
          pages {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          favorite {
            parentId
            badge
            type
            position
            activeOptions
          }
          enableFavorite
        }
        list {
          pages {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          favorite {
            parentId
            badge
            type
            position
            activeOptions
          }
          shortcuts {
            type
            title
            itemName
            itemPrice
            active
          }
        }
        navOrder
      }
      menus {
        parentId
        position
        page
        pageTitle
      }
      favMenus {
        parentId
        position
        page
        pageTitle
      }
      catMenus {
        title
        index
        ids
        parentId
      }
      market {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        paused
        takeoutDiscount
        creditDiscount
        takeout
        intro
        notice
        bookTable
        bookTableNote
        depositAmount
        delivery
        deliveryFee {
          start
          end
          fee
        }
        waitingTime
        itemIds
        updatedAt
        createdAt
      }
      waiting {
        status
        waitingOptions {
          id
          type
          name
          nameMl {
            en
            zh
            ja
          }
          items {
            id
            name
            nameMl {
              en
              zh
              ja
            }
            limitQuantity
          }
          required
          updatedAt
          createdAt
        }
        waitingMinutes
        waitingMinutesHide
        hasForeigner
        foreignerMethod
        notifications {
          created
          ready
          requested
          cancelled
        }
        notices {
          createdNotice
          createdNoticeMl {
            en
            zh
            ja
          }
          requestedNotice
          requestedNoticeMl {
            en
            zh
            ja
          }
        }
        settings {
          autoCancel
          autoCancelMinutes
        }
        updatedAt
        createdAt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      view {
        order {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
        itemReport {
          excludeColumns
        }
        summaryReport {
          excludeColumns
        }
        shippingOrder {
          excludeColumns
        }
        trsItemReport {
          excludeColumns
        }
        customReport {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
      }
      subscription {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        updatedAt
        createdAt
      }
      settings {
        mode
        table
        diningOption
        retailOption
        orderAlarm
        orderConfirm
        addressInput
        autoPay
        autoReturnItem
        autoSoldout
        menuGridSize
        menuMode
        tableMode
        orderNotify
        orderNotifySkippable
        disablePhonePrefix
        autoCloseScreen
        orderNumberPrefix {
          pos
          kiosk
          menuOrder
        }
        orderMgmt {
          kiosk
          menuorder
          delivery
          pos
        }
        reportBasis
        orderOrigins
        beeper {
          active
          coverage
          skippable
        }
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        customerOptions {
          countries
          ages
          gender
        }
      }
      devices {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      tables {
        id
        width
        height
        name
        axisX
        axisY
        screenHeight
        screenWidth
        initialX
        initialY
        shape
        layout {
          x
          y
          w
          h
        }
        color
        orderId
        disabled
      }
      boardTables {
        title
        index
        items {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
      }
      gridTables {
        id
        name
        orderId
        index
        page
      }
      modifierSoldoutIds
      delivery {
        baemin
        coupang
        yogiyo
        enableGenProd
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
      sales {
        startedAt
        endedAt
        reserves
        actualBalance
        currency
        note
        estimateBalance
        detail {
          totalSales
          totalRefund
          totalTax
          totalDiscount
          supplyAmount
          totalSalesCount
          cash {
            sales
            refund
          }
          card {
            sales
            refund
          }
          credit {
            sales
            refund
          }
          barcode {
            sales
            refund
          }
          extra {
            sales
            refund
          }
          refund {
            sales
            refund
          }
          products {
            id
            name
            quantity
            amount
          }
          origins {
            pos
            kiosk
            menuorder
            delivery
            market
          }
        }
        reservesHistories {
          type
          amount
          note
          createdEmployeeId
          createdAt
        }
      }
    }
  }
`;
export const onCreateBrand = /* GraphQL */ `
  subscription OnCreateBrand {
    onCreateBrand {
      id
      storeId
      name
      code
      description
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      state
      phone
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      menuPlanId
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      order
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateBrand = /* GraphQL */ `
  subscription OnUpdateBrand {
    onUpdateBrand {
      id
      storeId
      name
      code
      description
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      state
      phone
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      menuPlanId
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      order
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteBrand = /* GraphQL */ `
  subscription OnDeleteBrand {
    onDeleteBrand {
      id
      storeId
      name
      code
      description
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      state
      phone
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      menuPlanId
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      order
      createdAt
      updatedAt
    }
  }
`;
export const onCreateProductCodeRule = /* GraphQL */ `
  subscription OnCreateProductCodeRule {
    onCreateProductCodeRule {
      id
      storeId
      name
      brandId
      productComponents {
        componentType
        digit
        values {
          name
          code
        }
      }
      optionComponents {
        componentType
        digit
        values {
          name
          code
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateProductCodeRule = /* GraphQL */ `
  subscription OnUpdateProductCodeRule {
    onUpdateProductCodeRule {
      id
      storeId
      name
      brandId
      productComponents {
        componentType
        digit
        values {
          name
          code
        }
      }
      optionComponents {
        componentType
        digit
        values {
          name
          code
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteProductCodeRule = /* GraphQL */ `
  subscription OnDeleteProductCodeRule {
    onDeleteProductCodeRule {
      id
      storeId
      name
      brandId
      productComponents {
        componentType
        digit
        values {
          name
          code
        }
      }
      optionComponents {
        componentType
        digit
        values {
          name
          code
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateLocationDeviceDelta = /* GraphQL */ `
  subscription OnCreateLocationDeviceDelta {
    onCreateLocationDeviceDelta {
      id
      ident
      storeId
      locationId
      system
      ipAddress
      brand
      model
      name
      type
      deviceType
      display {
        height
        width
      }
      protocol
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      barcodeReader
      appVersion
      sysVersion
      status
      password
      msgToken
      msgTokenStatus
      parentId
      childId
      sleepMode
      kioskOptions {
        mode
        isActive
        tableId
        orderId
        callable
        payable
        enableDiningOption
        resetTime
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        columnSize
      }
      menuOrderOptions {
        tableId
        orderId
      }
      terminalId
      orderOptions {
        cycleNumber
      }
      printOptions {
        port
        baudRate
        receipt
        receiptButtonHide
        storeNameHide
        bills
        refund
        salesEnd
        order
        orderBeep
        orderCount
        orderExcludeIds
        delivery
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdateLocationDeviceDelta = /* GraphQL */ `
  subscription OnUpdateLocationDeviceDelta {
    onUpdateLocationDeviceDelta {
      id
      ident
      storeId
      locationId
      system
      ipAddress
      brand
      model
      name
      type
      deviceType
      display {
        height
        width
      }
      protocol
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      barcodeReader
      appVersion
      sysVersion
      status
      password
      msgToken
      msgTokenStatus
      parentId
      childId
      sleepMode
      kioskOptions {
        mode
        isActive
        tableId
        orderId
        callable
        payable
        enableDiningOption
        resetTime
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        columnSize
      }
      menuOrderOptions {
        tableId
        orderId
      }
      terminalId
      orderOptions {
        cycleNumber
      }
      printOptions {
        port
        baudRate
        receipt
        receiptButtonHide
        storeNameHide
        bills
        refund
        salesEnd
        order
        orderBeep
        orderCount
        orderExcludeIds
        delivery
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onDeleteLocationDeviceDelta = /* GraphQL */ `
  subscription OnDeleteLocationDeviceDelta {
    onDeleteLocationDeviceDelta {
      id
      ident
      storeId
      locationId
      system
      ipAddress
      brand
      model
      name
      type
      deviceType
      display {
        height
        width
      }
      protocol
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      barcodeReader
      appVersion
      sysVersion
      status
      password
      msgToken
      msgTokenStatus
      parentId
      childId
      sleepMode
      kioskOptions {
        mode
        isActive
        tableId
        orderId
        callable
        payable
        enableDiningOption
        resetTime
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        columnSize
      }
      menuOrderOptions {
        tableId
        orderId
      }
      terminalId
      orderOptions {
        cycleNumber
      }
      printOptions {
        port
        baudRate
        receipt
        receiptButtonHide
        storeNameHide
        bills
        refund
        salesEnd
        order
        orderBeep
        orderCount
        orderExcludeIds
        delivery
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onCreateBillingPolicy = /* GraphQL */ `
  subscription OnCreateBillingPolicy {
    onCreateBillingPolicy {
      id
      exemption
      exemptionLocations
      marketBrokerageRate
      subscriptionBrokerageRate
      locationFee
      note
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateBillingPolicy = /* GraphQL */ `
  subscription OnUpdateBillingPolicy {
    onUpdateBillingPolicy {
      id
      exemption
      exemptionLocations
      marketBrokerageRate
      subscriptionBrokerageRate
      locationFee
      note
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteBillingPolicy = /* GraphQL */ `
  subscription OnDeleteBillingPolicy {
    onDeleteBillingPolicy {
      id
      exemption
      exemptionLocations
      marketBrokerageRate
      subscriptionBrokerageRate
      locationFee
      note
      updatedAt
      createdAt
    }
  }
`;
export const onCreateContractSubscriptionPlan = /* GraphQL */ `
  subscription OnCreateContractSubscriptionPlan {
    onCreateContractSubscriptionPlan {
      id
      name
      type
      minCount
      maxCount
      price
      billingCycle
      yearDiscountRate
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateContractSubscriptionPlan = /* GraphQL */ `
  subscription OnUpdateContractSubscriptionPlan {
    onUpdateContractSubscriptionPlan {
      id
      name
      type
      minCount
      maxCount
      price
      billingCycle
      yearDiscountRate
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteContractSubscriptionPlan = /* GraphQL */ `
  subscription OnDeleteContractSubscriptionPlan {
    onDeleteContractSubscriptionPlan {
      id
      name
      type
      minCount
      maxCount
      price
      billingCycle
      yearDiscountRate
      updatedAt
      createdAt
    }
  }
`;
export const onCreateLocationContract = /* GraphQL */ `
  subscription OnCreateLocationContract {
    onCreateLocationContract {
      id
      businessOperatorId
      menuOrderExemptionQuantity
      menuOrderQuantity
      menuOrderStartedAt
      menuOrderRecurringType
      taxRefund
      note
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateLocationContract = /* GraphQL */ `
  subscription OnUpdateLocationContract {
    onUpdateLocationContract {
      id
      businessOperatorId
      menuOrderExemptionQuantity
      menuOrderQuantity
      menuOrderStartedAt
      menuOrderRecurringType
      taxRefund
      note
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteLocationContract = /* GraphQL */ `
  subscription OnDeleteLocationContract {
    onDeleteLocationContract {
      id
      businessOperatorId
      menuOrderExemptionQuantity
      menuOrderQuantity
      menuOrderStartedAt
      menuOrderRecurringType
      taxRefund
      note
      updatedAt
      createdAt
    }
  }
`;
export const onCreateStoreContract = /* GraphQL */ `
  subscription OnCreateStoreContract {
    onCreateStoreContract {
      id
      businessOperatorId
      menuOrderExemptionQuantity
      menuOrderQuantity
      menuOrderStartedAt
      menuOrderRecurringType
      taxRefund
      note
      cafe24
      imweb
      subscribed
      subscriptions {
        planId
        type
        status
        name
        billingCycle
        nextBillingCycle
        nextPlanId
        monthExtraPrice
        startedAt
        expiryDate
        canceledAt
        updatedAt
        createdAt
      }
      providerFee
      multiLocation
      locationFee
      locationFeeType
      locationFeeExemptionIds
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateStoreContract = /* GraphQL */ `
  subscription OnUpdateStoreContract {
    onUpdateStoreContract {
      id
      businessOperatorId
      menuOrderExemptionQuantity
      menuOrderQuantity
      menuOrderStartedAt
      menuOrderRecurringType
      taxRefund
      note
      cafe24
      imweb
      subscribed
      subscriptions {
        planId
        type
        status
        name
        billingCycle
        nextBillingCycle
        nextPlanId
        monthExtraPrice
        startedAt
        expiryDate
        canceledAt
        updatedAt
        createdAt
      }
      providerFee
      multiLocation
      locationFee
      locationFeeType
      locationFeeExemptionIds
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteStoreContract = /* GraphQL */ `
  subscription OnDeleteStoreContract {
    onDeleteStoreContract {
      id
      businessOperatorId
      menuOrderExemptionQuantity
      menuOrderQuantity
      menuOrderStartedAt
      menuOrderRecurringType
      taxRefund
      note
      cafe24
      imweb
      subscribed
      subscriptions {
        planId
        type
        status
        name
        billingCycle
        nextBillingCycle
        nextPlanId
        monthExtraPrice
        startedAt
        expiryDate
        canceledAt
        updatedAt
        createdAt
      }
      providerFee
      multiLocation
      locationFee
      locationFeeType
      locationFeeExemptionIds
      updatedAt
      createdAt
    }
  }
`;
export const onCreateSubscriptionEvent = /* GraphQL */ `
  subscription OnCreateSubscriptionEvent {
    onCreateSubscriptionEvent {
      id
      storeId
      locationId
      subscriptionId
      sessionId
      planId
      price
      amount
      currency
      type
      customerId
      storeCustomerId
      orderId
      orderNumberPrefix
      orderNumber
      startDate
      endDate
      updatedAt
      createdAt
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      plan {
        id
        storeId
        productId
        skuId
        name
        recurringType
        recurringValue
        price
        quantity
        status
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        gracePeriod
        subscriberCount
        locations {
          planId
          locationId
          available
          subscriberCount
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onUpdateSubscriptionEvent = /* GraphQL */ `
  subscription OnUpdateSubscriptionEvent {
    onUpdateSubscriptionEvent {
      id
      storeId
      locationId
      subscriptionId
      sessionId
      planId
      price
      amount
      currency
      type
      customerId
      storeCustomerId
      orderId
      orderNumberPrefix
      orderNumber
      startDate
      endDate
      updatedAt
      createdAt
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      plan {
        id
        storeId
        productId
        skuId
        name
        recurringType
        recurringValue
        price
        quantity
        status
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        gracePeriod
        subscriberCount
        locations {
          planId
          locationId
          available
          subscriberCount
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onDeleteSubscriptionEvent = /* GraphQL */ `
  subscription OnDeleteSubscriptionEvent {
    onDeleteSubscriptionEvent {
      id
      storeId
      locationId
      subscriptionId
      sessionId
      planId
      price
      amount
      currency
      type
      customerId
      storeCustomerId
      orderId
      orderNumberPrefix
      orderNumber
      startDate
      endDate
      updatedAt
      createdAt
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      plan {
        id
        storeId
        productId
        skuId
        name
        recurringType
        recurringValue
        price
        quantity
        status
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        gracePeriod
        subscriberCount
        locations {
          planId
          locationId
          available
          subscriberCount
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onCreateSubscriptionPlanDelta = /* GraphQL */ `
  subscription OnCreateSubscriptionPlanDelta {
    onCreateSubscriptionPlanDelta {
      id
      storeId
      productId
      skuId
      name
      recurringType
      recurringValue
      price
      quantity
      status
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      gracePeriod
      subscriberCount
      locations {
        planId
        locationId
        available
        subscriberCount
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onUpdateSubscriptionPlanDelta = /* GraphQL */ `
  subscription OnUpdateSubscriptionPlanDelta {
    onUpdateSubscriptionPlanDelta {
      id
      storeId
      productId
      skuId
      name
      recurringType
      recurringValue
      price
      quantity
      status
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      gracePeriod
      subscriberCount
      locations {
        planId
        locationId
        available
        subscriberCount
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onDeleteSubscriptionPlanDelta = /* GraphQL */ `
  subscription OnDeleteSubscriptionPlanDelta {
    onDeleteSubscriptionPlanDelta {
      id
      storeId
      productId
      skuId
      name
      recurringType
      recurringValue
      price
      quantity
      status
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      gracePeriod
      subscriberCount
      locations {
        planId
        locationId
        available
        subscriberCount
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const onCreateStoreCreditTransaction = /* GraphQL */ `
  subscription OnCreateStoreCreditTransaction {
    onCreateStoreCreditTransaction {
      id
      type
      origin
      method
      storeId
      locationId
      referId
      name
      quantity
      price
      amount
      currency
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateStoreCreditTransaction = /* GraphQL */ `
  subscription OnUpdateStoreCreditTransaction {
    onUpdateStoreCreditTransaction {
      id
      type
      origin
      method
      storeId
      locationId
      referId
      name
      quantity
      price
      amount
      currency
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteStoreCreditTransaction = /* GraphQL */ `
  subscription OnDeleteStoreCreditTransaction {
    onDeleteStoreCreditTransaction {
      id
      type
      origin
      method
      storeId
      locationId
      referId
      name
      quantity
      price
      amount
      currency
      createdAt
      updatedAt
    }
  }
`;
export const onCreateStore = /* GraphQL */ `
  subscription OnCreateStore {
    onCreateStore {
      id
      enterpriseId
      info {
        name
        phone
        email
        representative
        businessType
        businessNumber
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        industryType
        sendNumber
        currency
        address
        zip
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        csPhone
      }
      policy {
        multiLocation
        provider {
          key
          ident
          customer
          customerQr
          coupon
          inventory
          inventoryLocationId
          locationId
          userId
          userPassword
          shopMap {
            storeId
            shopNo
            name
            originName
            countryCode
            usableCouponIds
            currencyCode
            tiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
        }
        app {
          locationId
        }
      }
      currency
      payments {
        card
        cardJoined
        cash
        credit
        refund
      }
      devices {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      plans {
        menus {
          id
          name
          mode
          size
          menus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          pages {
            index
            parentId
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            title
            titleMl {
              en
              zh
              ja
            }
          }
          updatedAt
          createdAt
        }
        orders {
          id
          name
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          updatedAt
          createdAt
        }
      }
      taxes {
        id
        type
        name
        enabled
        rate
        method
        targetType
      }
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      subscription {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        updatedAt
        createdAt
      }
      view {
        order {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
        itemReport {
          excludeColumns
        }
        summaryReport {
          excludeColumns
        }
        shippingOrder {
          excludeColumns
        }
        trsItemReport {
          excludeColumns
        }
        customReport {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
      }
      settings {
        mode
        table
        diningOption
        retailOption
        orderAlarm
        orderConfirm
        addressInput
        autoPay
        autoReturnItem
        autoSoldout
        menuGridSize
        menuMode
        tableMode
        orderNotify
        orderNotifySkippable
        disablePhonePrefix
        autoCloseScreen
        orderNumberPrefix {
          pos
          kiosk
          menuOrder
        }
        orderMgmt {
          kiosk
          menuorder
          delivery
          pos
        }
        reportBasis
        orderOrigins
        beeper {
          active
          coverage
          skippable
        }
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        customerOptions {
          countries
          ages
          gender
        }
      }
      item {
        attributes {
          name
          type
          value
        }
        actualPrice
        skuMgmt
        barcodeMgmt
        stockTrack
        variablePrice
        locationCreatable
      }
      inventory {
        attributes {
          name
          type
          value
        }
        expiryDateMgmt
        expiryDateAlertDays
        hqWhExposureEnabled
        hqWhExposureLocIds
        hqWhUnexposureLocIds
        customAdjustDateEnabled
      }
      customer {
        attributes {
          name
          type
          value
        }
      }
      billing {
        key
        businessNumber
        name
        email
        phone
        contanctName
        contactName
        address
        zip
        card {
          pg
          number
          name
          expMonth
          expYear
          identify
          password
          billingKey
        }
      }
      credit {
        autoCharge
        autoChargeCredit
        autoChargeQuantity
        alertCredit
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      review {
        status
        campaignId
        updatedAt
        createdAt
      }
      kiosk {
        status
        callable
        payable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        exchangeTicket
        columnSize
        discounts {
          condition
          couponId
        }
        menuDescription
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        titles
        titlePosition
        updatedAt
        createdAt
      }
      menuOrder {
        callOptions {
          index
          label
        }
        orderable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        columnSize
        fontSize
        notice
        resetTime
        enableCash
        boardType
      }
      kds {
        layout
        alerts {
          urgent
          warning
        }
        disabledProdIds
        orderNotify
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      market {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        paused
        takeoutDiscount
        creditDiscount
        takeout
        intro
        notice
        bookTable
        bookTableNote
        depositAmount
        delivery
        deliveryFee {
          start
          end
          fee
        }
        waitingTime
        itemIds
        updatedAt
        createdAt
      }
      notification {
        options {
          type
          email
          sms
        }
      }
      groups {
        items {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      locations {
        items {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const onUpdateStore = /* GraphQL */ `
  subscription OnUpdateStore {
    onUpdateStore {
      id
      enterpriseId
      info {
        name
        phone
        email
        representative
        businessType
        businessNumber
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        industryType
        sendNumber
        currency
        address
        zip
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        csPhone
      }
      policy {
        multiLocation
        provider {
          key
          ident
          customer
          customerQr
          coupon
          inventory
          inventoryLocationId
          locationId
          userId
          userPassword
          shopMap {
            storeId
            shopNo
            name
            originName
            countryCode
            usableCouponIds
            currencyCode
            tiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
        }
        app {
          locationId
        }
      }
      currency
      payments {
        card
        cardJoined
        cash
        credit
        refund
      }
      devices {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      plans {
        menus {
          id
          name
          mode
          size
          menus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          pages {
            index
            parentId
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            title
            titleMl {
              en
              zh
              ja
            }
          }
          updatedAt
          createdAt
        }
        orders {
          id
          name
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          updatedAt
          createdAt
        }
      }
      taxes {
        id
        type
        name
        enabled
        rate
        method
        targetType
      }
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      subscription {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        updatedAt
        createdAt
      }
      view {
        order {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
        itemReport {
          excludeColumns
        }
        summaryReport {
          excludeColumns
        }
        shippingOrder {
          excludeColumns
        }
        trsItemReport {
          excludeColumns
        }
        customReport {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
      }
      settings {
        mode
        table
        diningOption
        retailOption
        orderAlarm
        orderConfirm
        addressInput
        autoPay
        autoReturnItem
        autoSoldout
        menuGridSize
        menuMode
        tableMode
        orderNotify
        orderNotifySkippable
        disablePhonePrefix
        autoCloseScreen
        orderNumberPrefix {
          pos
          kiosk
          menuOrder
        }
        orderMgmt {
          kiosk
          menuorder
          delivery
          pos
        }
        reportBasis
        orderOrigins
        beeper {
          active
          coverage
          skippable
        }
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        customerOptions {
          countries
          ages
          gender
        }
      }
      item {
        attributes {
          name
          type
          value
        }
        actualPrice
        skuMgmt
        barcodeMgmt
        stockTrack
        variablePrice
        locationCreatable
      }
      inventory {
        attributes {
          name
          type
          value
        }
        expiryDateMgmt
        expiryDateAlertDays
        hqWhExposureEnabled
        hqWhExposureLocIds
        hqWhUnexposureLocIds
        customAdjustDateEnabled
      }
      customer {
        attributes {
          name
          type
          value
        }
      }
      billing {
        key
        businessNumber
        name
        email
        phone
        contanctName
        contactName
        address
        zip
        card {
          pg
          number
          name
          expMonth
          expYear
          identify
          password
          billingKey
        }
      }
      credit {
        autoCharge
        autoChargeCredit
        autoChargeQuantity
        alertCredit
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      review {
        status
        campaignId
        updatedAt
        createdAt
      }
      kiosk {
        status
        callable
        payable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        exchangeTicket
        columnSize
        discounts {
          condition
          couponId
        }
        menuDescription
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        titles
        titlePosition
        updatedAt
        createdAt
      }
      menuOrder {
        callOptions {
          index
          label
        }
        orderable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        columnSize
        fontSize
        notice
        resetTime
        enableCash
        boardType
      }
      kds {
        layout
        alerts {
          urgent
          warning
        }
        disabledProdIds
        orderNotify
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      market {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        paused
        takeoutDiscount
        creditDiscount
        takeout
        intro
        notice
        bookTable
        bookTableNote
        depositAmount
        delivery
        deliveryFee {
          start
          end
          fee
        }
        waitingTime
        itemIds
        updatedAt
        createdAt
      }
      notification {
        options {
          type
          email
          sms
        }
      }
      groups {
        items {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      locations {
        items {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const onDeleteStore = /* GraphQL */ `
  subscription OnDeleteStore {
    onDeleteStore {
      id
      enterpriseId
      info {
        name
        phone
        email
        representative
        businessType
        businessNumber
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        industryType
        sendNumber
        currency
        address
        zip
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        csPhone
      }
      policy {
        multiLocation
        provider {
          key
          ident
          customer
          customerQr
          coupon
          inventory
          inventoryLocationId
          locationId
          userId
          userPassword
          shopMap {
            storeId
            shopNo
            name
            originName
            countryCode
            usableCouponIds
            currencyCode
            tiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
        }
        app {
          locationId
        }
      }
      currency
      payments {
        card
        cardJoined
        cash
        credit
        refund
      }
      devices {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      plans {
        menus {
          id
          name
          mode
          size
          menus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          pages {
            index
            parentId
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            title
            titleMl {
              en
              zh
              ja
            }
          }
          updatedAt
          createdAt
        }
        orders {
          id
          name
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          updatedAt
          createdAt
        }
      }
      taxes {
        id
        type
        name
        enabled
        rate
        method
        targetType
      }
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      subscription {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        updatedAt
        createdAt
      }
      view {
        order {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
        itemReport {
          excludeColumns
        }
        summaryReport {
          excludeColumns
        }
        shippingOrder {
          excludeColumns
        }
        trsItemReport {
          excludeColumns
        }
        customReport {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
      }
      settings {
        mode
        table
        diningOption
        retailOption
        orderAlarm
        orderConfirm
        addressInput
        autoPay
        autoReturnItem
        autoSoldout
        menuGridSize
        menuMode
        tableMode
        orderNotify
        orderNotifySkippable
        disablePhonePrefix
        autoCloseScreen
        orderNumberPrefix {
          pos
          kiosk
          menuOrder
        }
        orderMgmt {
          kiosk
          menuorder
          delivery
          pos
        }
        reportBasis
        orderOrigins
        beeper {
          active
          coverage
          skippable
        }
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        customerOptions {
          countries
          ages
          gender
        }
      }
      item {
        attributes {
          name
          type
          value
        }
        actualPrice
        skuMgmt
        barcodeMgmt
        stockTrack
        variablePrice
        locationCreatable
      }
      inventory {
        attributes {
          name
          type
          value
        }
        expiryDateMgmt
        expiryDateAlertDays
        hqWhExposureEnabled
        hqWhExposureLocIds
        hqWhUnexposureLocIds
        customAdjustDateEnabled
      }
      customer {
        attributes {
          name
          type
          value
        }
      }
      billing {
        key
        businessNumber
        name
        email
        phone
        contanctName
        contactName
        address
        zip
        card {
          pg
          number
          name
          expMonth
          expYear
          identify
          password
          billingKey
        }
      }
      credit {
        autoCharge
        autoChargeCredit
        autoChargeQuantity
        alertCredit
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      review {
        status
        campaignId
        updatedAt
        createdAt
      }
      kiosk {
        status
        callable
        payable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        exchangeTicket
        columnSize
        discounts {
          condition
          couponId
        }
        menuDescription
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        titles
        titlePosition
        updatedAt
        createdAt
      }
      menuOrder {
        callOptions {
          index
          label
        }
        orderable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        columnSize
        fontSize
        notice
        resetTime
        enableCash
        boardType
      }
      kds {
        layout
        alerts {
          urgent
          warning
        }
        disabledProdIds
        orderNotify
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      market {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        paused
        takeoutDiscount
        creditDiscount
        takeout
        intro
        notice
        bookTable
        bookTableNote
        depositAmount
        delivery
        deliveryFee {
          start
          end
          fee
        }
        waitingTime
        itemIds
        updatedAt
        createdAt
      }
      notification {
        options {
          type
          email
          sms
        }
      }
      groups {
        items {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      locations {
        items {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const onCreateShippingConfig = /* GraphQL */ `
  subscription OnCreateShippingConfig {
    onCreateShippingConfig {
      id
      storeId
      brandId
      senderLocationId
      returnLocationId
      stockLimitedPrint
      reprintWarning
      overflowItemMode
      printSortKeys
      provisionEnabled
      batchShipEnabled
      carrierId
      unusedWaybillAlertDays
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateShippingConfig = /* GraphQL */ `
  subscription OnUpdateShippingConfig {
    onUpdateShippingConfig {
      id
      storeId
      brandId
      senderLocationId
      returnLocationId
      stockLimitedPrint
      reprintWarning
      overflowItemMode
      printSortKeys
      provisionEnabled
      batchShipEnabled
      carrierId
      unusedWaybillAlertDays
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteShippingConfig = /* GraphQL */ `
  subscription OnDeleteShippingConfig {
    onDeleteShippingConfig {
      id
      storeId
      brandId
      senderLocationId
      returnLocationId
      stockLimitedPrint
      reprintWarning
      overflowItemMode
      printSortKeys
      provisionEnabled
      batchShipEnabled
      carrierId
      unusedWaybillAlertDays
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCarrier = /* GraphQL */ `
  subscription OnCreateCarrier {
    onCreateCarrier {
      id
      storeId
      code
      name
      enabled
      credentials
      prepaidContract
      templates {
        id
        name
        carrierCode
        paperType
        isDefault
        offsetX
        offsetY
        logoUrl
        fixedText
        giftMark {
          enabled
          text
          position
        }
        itemLineNumber {
          enabled
          format
        }
        maxItemRows
        emphasizeMultiQty
        mergeSameItemQty
        splitLineByProduct
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCarrier = /* GraphQL */ `
  subscription OnUpdateCarrier {
    onUpdateCarrier {
      id
      storeId
      code
      name
      enabled
      credentials
      prepaidContract
      templates {
        id
        name
        carrierCode
        paperType
        isDefault
        offsetX
        offsetY
        logoUrl
        fixedText
        giftMark {
          enabled
          text
          position
        }
        itemLineNumber {
          enabled
          format
        }
        maxItemRows
        emphasizeMultiQty
        mergeSameItemQty
        splitLineByProduct
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCarrier = /* GraphQL */ `
  subscription OnDeleteCarrier {
    onDeleteCarrier {
      id
      storeId
      code
      name
      enabled
      credentials
      prepaidContract
      templates {
        id
        name
        carrierCode
        paperType
        isDefault
        offsetX
        offsetY
        logoUrl
        fixedText
        giftMark {
          enabled
          text
          position
        }
        itemLineNumber {
          enabled
          format
        }
        maxItemRows
        emphasizeMultiQty
        mergeSameItemQty
        splitLineByProduct
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCarrierToken = /* GraphQL */ `
  subscription OnCreateCarrierToken {
    onCreateCarrierToken {
      id
      token
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCarrierToken = /* GraphQL */ `
  subscription OnUpdateCarrierToken {
    onUpdateCarrierToken {
      id
      token
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCarrierToken = /* GraphQL */ `
  subscription OnDeleteCarrierToken {
    onDeleteCarrierToken {
      id
      token
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const onCreateStoreStatus = /* GraphQL */ `
  subscription OnCreateStoreStatus {
    onCreateStoreStatus {
      id
      item {
        func
        progress
        errorMessage
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateStoreStatus = /* GraphQL */ `
  subscription OnUpdateStoreStatus {
    onUpdateStoreStatus {
      id
      item {
        func
        progress
        errorMessage
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteStoreStatus = /* GraphQL */ `
  subscription OnDeleteStoreStatus {
    onDeleteStoreStatus {
      id
      item {
        func
        progress
        errorMessage
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateRequestProgressEvent = /* GraphQL */ `
  subscription OnCreateRequestProgressEvent {
    onCreateRequestProgressEvent {
      id
      origin
      originId
      func
      params
      status
      progress
      errorMessage
      doneAt
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateRequestProgressEvent = /* GraphQL */ `
  subscription OnUpdateRequestProgressEvent {
    onUpdateRequestProgressEvent {
      id
      origin
      originId
      func
      params
      status
      progress
      errorMessage
      doneAt
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteRequestProgressEvent = /* GraphQL */ `
  subscription OnDeleteRequestProgressEvent {
    onDeleteRequestProgressEvent {
      id
      origin
      originId
      func
      params
      status
      progress
      errorMessage
      doneAt
      updatedAt
      createdAt
    }
  }
`;
export const onCreateLocationStats = /* GraphQL */ `
  subscription OnCreateLocationStats {
    onCreateLocationStats {
      id
      sales {
        date
        yesterday
        today
        thisMonthCount
      }
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateLocationStats = /* GraphQL */ `
  subscription OnUpdateLocationStats {
    onUpdateLocationStats {
      id
      sales {
        date
        yesterday
        today
        thisMonthCount
      }
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteLocationStats = /* GraphQL */ `
  subscription OnDeleteLocationStats {
    onDeleteLocationStats {
      id
      sales {
        date
        yesterday
        today
        thisMonthCount
      }
      updatedAt
      createdAt
    }
  }
`;
export const onCreateBusinessOperator = /* GraphQL */ `
  subscription OnCreateBusinessOperator {
    onCreateBusinessOperator {
      id
      businessNumber
      name
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateBusinessOperator = /* GraphQL */ `
  subscription OnUpdateBusinessOperator {
    onUpdateBusinessOperator {
      id
      businessNumber
      name
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteBusinessOperator = /* GraphQL */ `
  subscription OnDeleteBusinessOperator {
    onDeleteBusinessOperator {
      id
      businessNumber
      name
      createdAt
      updatedAt
    }
  }
`;
export const onCreateStoreCustomer = /* GraphQL */ `
  subscription OnCreateStoreCustomer {
    onCreateStoreCustomer {
      id
      customerId
      storeId
      sources {
        id
        type
        name
        ident
        createdAt
      }
      isFavorite
      locationId
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      favoriteLocationIds
      visitedLocationIds
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      status
      registeredAt
      campaignBlockedAt
      note
      removedAt
      updatedAt
      createdAt
      points {
        items {
          id
          locationId
          storeId
          type
          name
          method
          amount
          origin
          provider
          providerCustomerId
          providerShopNo
          providerSyncedAt
          currency
          point
          extraPoint
          extraExpire
          items {
            type
            itemId
            name
            parentId
            point
            amount
            quantity
          }
          quantity
          note
          orderId
          referId
          orderNumberPrefix
          orderNumber
          customerId
          pointTransactionCustomerId
          expiredAt
          salesDate
          eventId
          updatedAt
          createdAt
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
        }
        nextToken
      }
      credits {
        items {
          id
          locationId
          storeId
          name
          type
          amount
          origin
          note
          currency
          parentId
          orderId
          orderNumberPrefix
          orderNumber
          customerId
          creditTransactionCustomerId
          description
          salesDate
          createdAt
          updatedAt
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
        }
        nextToken
      }
      _delta
      orders {
        items {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          giftReceiverKey
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
        nextToken
      }
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
      customer {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onUpdateStoreCustomer = /* GraphQL */ `
  subscription OnUpdateStoreCustomer {
    onUpdateStoreCustomer {
      id
      customerId
      storeId
      sources {
        id
        type
        name
        ident
        createdAt
      }
      isFavorite
      locationId
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      favoriteLocationIds
      visitedLocationIds
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      status
      registeredAt
      campaignBlockedAt
      note
      removedAt
      updatedAt
      createdAt
      points {
        items {
          id
          locationId
          storeId
          type
          name
          method
          amount
          origin
          provider
          providerCustomerId
          providerShopNo
          providerSyncedAt
          currency
          point
          extraPoint
          extraExpire
          items {
            type
            itemId
            name
            parentId
            point
            amount
            quantity
          }
          quantity
          note
          orderId
          referId
          orderNumberPrefix
          orderNumber
          customerId
          pointTransactionCustomerId
          expiredAt
          salesDate
          eventId
          updatedAt
          createdAt
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
        }
        nextToken
      }
      credits {
        items {
          id
          locationId
          storeId
          name
          type
          amount
          origin
          note
          currency
          parentId
          orderId
          orderNumberPrefix
          orderNumber
          customerId
          creditTransactionCustomerId
          description
          salesDate
          createdAt
          updatedAt
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
        }
        nextToken
      }
      _delta
      orders {
        items {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          giftReceiverKey
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
        nextToken
      }
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
      customer {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onDeleteStoreCustomer = /* GraphQL */ `
  subscription OnDeleteStoreCustomer {
    onDeleteStoreCustomer {
      id
      customerId
      storeId
      sources {
        id
        type
        name
        ident
        createdAt
      }
      isFavorite
      locationId
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      favoriteLocationIds
      visitedLocationIds
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      status
      registeredAt
      campaignBlockedAt
      note
      removedAt
      updatedAt
      createdAt
      points {
        items {
          id
          locationId
          storeId
          type
          name
          method
          amount
          origin
          provider
          providerCustomerId
          providerShopNo
          providerSyncedAt
          currency
          point
          extraPoint
          extraExpire
          items {
            type
            itemId
            name
            parentId
            point
            amount
            quantity
          }
          quantity
          note
          orderId
          referId
          orderNumberPrefix
          orderNumber
          customerId
          pointTransactionCustomerId
          expiredAt
          salesDate
          eventId
          updatedAt
          createdAt
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
        }
        nextToken
      }
      credits {
        items {
          id
          locationId
          storeId
          name
          type
          amount
          origin
          note
          currency
          parentId
          orderId
          orderNumberPrefix
          orderNumber
          customerId
          creditTransactionCustomerId
          description
          salesDate
          createdAt
          updatedAt
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
        }
        nextToken
      }
      _delta
      orders {
        items {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          giftReceiverKey
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
        nextToken
      }
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
          app {
            locationId
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
      customer {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onCreateCustomer = /* GraphQL */ `
  subscription OnCreateCustomer {
    onCreateCustomer {
      id
      ident
      identType
      type
      name
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      updatedAt
      createdAt
      stores {
        items {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const onUpdateCustomer = /* GraphQL */ `
  subscription OnUpdateCustomer {
    onUpdateCustomer {
      id
      ident
      identType
      type
      name
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      updatedAt
      createdAt
      stores {
        items {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const onDeleteCustomer = /* GraphQL */ `
  subscription OnDeleteCustomer {
    onDeleteCustomer {
      id
      ident
      identType
      type
      name
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      updatedAt
      createdAt
      stores {
        items {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              giftReceiverKey
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
              app {
                locationId
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const onCreateStoreCustomerDelta = /* GraphQL */ `
  subscription OnCreateStoreCustomerDelta {
    onCreateStoreCustomerDelta {
      id
      customerId
      storeId
      locationId
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      campaignBlockedAt
      isFavorite
      favoriteLocationIds
      visitedLocationIds
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      customer {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onUpdateStoreCustomerDelta = /* GraphQL */ `
  subscription OnUpdateStoreCustomerDelta {
    onUpdateStoreCustomerDelta {
      id
      customerId
      storeId
      locationId
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      campaignBlockedAt
      isFavorite
      favoriteLocationIds
      visitedLocationIds
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      customer {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onDeleteStoreCustomerDelta = /* GraphQL */ `
  subscription OnDeleteStoreCustomerDelta {
    onDeleteStoreCustomerDelta {
      id
      customerId
      storeId
      locationId
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      campaignBlockedAt
      isFavorite
      favoriteLocationIds
      visitedLocationIds
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      customer {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                giftReceiverKey
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const onCreateLocationCustomerDelta = /* GraphQL */ `
  subscription OnCreateLocationCustomerDelta {
    onCreateLocationCustomerDelta {
      id
      enterpriseId
      storeId
      locationId
      customerId
      provider
      providerCustomerId
      shopNo
      tier
      tierId
      customerCreatedAt
      ident
      identType
      type
      name
      nameKeyword
      payments {
        id
        method
        pg
        number
        name
        expMonth
        expYear
        billingKey
        updatedAt
        createdAt
      }
      attributes {
        name
        type
        value
      }
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      tags {
        tagId
        createdLocationId
      }
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      salesDate
      campaignBlockedAt
      blacklistedAt
      isFavorite
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      subscriptions {
        id
        planId
        payStatus
        sessionId
        nextPayDate
        paidAt
        unsubscribedAt
        used
        lastUsedAt
        orderId
        unsubscribeRequestedAt
        startDate
        expireDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdateLocationCustomerDelta = /* GraphQL */ `
  subscription OnUpdateLocationCustomerDelta {
    onUpdateLocationCustomerDelta {
      id
      enterpriseId
      storeId
      locationId
      customerId
      provider
      providerCustomerId
      shopNo
      tier
      tierId
      customerCreatedAt
      ident
      identType
      type
      name
      nameKeyword
      payments {
        id
        method
        pg
        number
        name
        expMonth
        expYear
        billingKey
        updatedAt
        createdAt
      }
      attributes {
        name
        type
        value
      }
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      tags {
        tagId
        createdLocationId
      }
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      salesDate
      campaignBlockedAt
      blacklistedAt
      isFavorite
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      subscriptions {
        id
        planId
        payStatus
        sessionId
        nextPayDate
        paidAt
        unsubscribedAt
        used
        lastUsedAt
        orderId
        unsubscribeRequestedAt
        startDate
        expireDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onDeleteLocationCustomerDelta = /* GraphQL */ `
  subscription OnDeleteLocationCustomerDelta {
    onDeleteLocationCustomerDelta {
      id
      enterpriseId
      storeId
      locationId
      customerId
      provider
      providerCustomerId
      shopNo
      tier
      tierId
      customerCreatedAt
      ident
      identType
      type
      name
      nameKeyword
      payments {
        id
        method
        pg
        number
        name
        expMonth
        expYear
        billingKey
        updatedAt
        createdAt
      }
      attributes {
        name
        type
        value
      }
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      tags {
        tagId
        createdLocationId
      }
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      salesDate
      campaignBlockedAt
      blacklistedAt
      isFavorite
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      subscriptions {
        id
        planId
        payStatus
        sessionId
        nextPayDate
        paidAt
        unsubscribedAt
        used
        lastUsedAt
        orderId
        unsubscribeRequestedAt
        startDate
        expireDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onCreateAlertEventHistory = /* GraphQL */ `
  subscription OnCreateAlertEventHistory {
    onCreateAlertEventHistory {
      id
      type
      parentId
      subParentId
      storeId
      locationId
      title
      message
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateAlertEventHistory = /* GraphQL */ `
  subscription OnUpdateAlertEventHistory {
    onUpdateAlertEventHistory {
      id
      type
      parentId
      subParentId
      storeId
      locationId
      title
      message
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteAlertEventHistory = /* GraphQL */ `
  subscription OnDeleteAlertEventHistory {
    onDeleteAlertEventHistory {
      id
      type
      parentId
      subParentId
      storeId
      locationId
      title
      message
      updatedAt
      createdAt
    }
  }
`;
export const onCreateCustomerRequestDelta = /* GraphQL */ `
  subscription OnCreateCustomerRequestDelta {
    onCreateCustomerRequestDelta {
      id
      storeId
      locationId
      messages
      orderId
      tableId
      parentDeviceId
      childDeviceId
      confirmedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdateCustomerRequestDelta = /* GraphQL */ `
  subscription OnUpdateCustomerRequestDelta {
    onUpdateCustomerRequestDelta {
      id
      storeId
      locationId
      messages
      orderId
      tableId
      parentDeviceId
      childDeviceId
      confirmedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onDeleteCustomerRequestDelta = /* GraphQL */ `
  subscription OnDeleteCustomerRequestDelta {
    onDeleteCustomerRequestDelta {
      id
      storeId
      locationId
      messages
      orderId
      tableId
      parentDeviceId
      childDeviceId
      confirmedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onCreateWaitingDelta = /* GraphQL */ `
  subscription OnCreateWaitingDelta {
    onCreateWaitingDelta {
      id
      storeId
      locationId
      status
      cancelledAt
      enteredAt
      readyAt
      requestedAt
      language
      number
      phone
      email
      visitors
      counter
      msgFailReason
      optionItems {
        optionId
        optionName
        optionItemId
        optionItemName
        quantity
      }
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      salesDate
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onUpdateWaitingDelta = /* GraphQL */ `
  subscription OnUpdateWaitingDelta {
    onUpdateWaitingDelta {
      id
      storeId
      locationId
      status
      cancelledAt
      enteredAt
      readyAt
      requestedAt
      language
      number
      phone
      email
      visitors
      counter
      msgFailReason
      optionItems {
        optionId
        optionName
        optionItemId
        optionItemName
        quantity
      }
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      salesDate
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const onDeleteWaitingDelta = /* GraphQL */ `
  subscription OnDeleteWaitingDelta {
    onDeleteWaitingDelta {
      id
      storeId
      locationId
      status
      cancelledAt
      enteredAt
      readyAt
      requestedAt
      language
      number
      phone
      email
      visitors
      counter
      msgFailReason
      optionItems {
        optionId
        optionName
        optionItemId
        optionItemName
        quantity
      }
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      salesDate
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
